<template>
	<div>
		<div class="box">
			<h2 class="match-header">{{community.name}}</h2>
				<md-card>
			      <md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5">Site Status</md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
          		<md-card-expand-content>
          			<md-card-content class="ptop0 card-content">
						<form @submit.prevent="submitSiteStatus('form-site-status')" autocomplete="off" data-vv-scope="form-site-status" class= "form-site-status">
							<div class=" md-layout-item md-medium-size-20">
								<md-field class="m-left-5 ">
									<label>Matching:</label>
									<md-select v-model="settings.matching" name="Matching"  v-validate="'required'" placeholder="Matching" id="matching">
										<md-option value="">Please select</md-option>
										<md-option value="Manual">Manual</md-option>
										<md-option value="Automated">Automated</md-option>
									</md-select>
								</md-field>
								<p class="error m-left-5" v-if="errors.has('form-site-status.Matching')">{{errors.first('form-site-status.Matching')}}</p>
							</div>
							<div class="md-layout-item md-medium-size-20">
								<md-field class="m-left-5 ">
									<label>Site Status:</label>
									<md-select v-model="settings.siteStatus" name="Site status"  v-validate="'required'" placeholder="Site status" id="siteStatus">
										<md-option value="Preview">Preview</md-option>
										<md-option value="Live">Live</md-option>
										<md-option value="Inactive">Inactive</md-option>
									</md-select>
								</md-field>
								<p class="error m-left-5" v-if="errors.has('form-site-status.Site status')">{{errors.first('form-site-status.Site status')}}</p>
							</div>
							<md-field class=" m-left-5">
								<label class="card-header">Internal Email Recipients</label>
								<md-input v-model.trim="settings.emails" name="Internal email recipients" v-validate="settings.siteStatus == 'Preview' ? 'required' : ''" placeholder="Internal email recipients..." md-autogrow @input="settings.emails = sanitizeInput($event)"></md-input>
								<span class="md-helper-text">Multiple email must be comma(,) separated</span>
							</md-field>
								<p class="error m-left-5" v-show="errors.has('form-site-status.Internal email recipients')">{{errors.first('form-site-status.Internal email recipients')}}</p>
							<md-field class=" m-left-5">
								<label class="card-header">Super Users</label>
								<md-input v-model.trim="settings.super_user_emails" name="super user emails" v-validate="superUserEmailValidate ? 'required' : ''"  placeholder="Super users emails..." md-autogrow @input="settings.super_user_emails = sanitizeInput($event)"></md-input>
								<span class="md-helper-text">Multiple email must be comma(,) separated</span>
							</md-field>
								<p class="error m-left-5" v-show="errors.has('form-site-status.Super Users')">{{errors.first('form-site-status.super user emails')}}</p>
							<div class="md-layout-item md-medium-size-40 m-left-5">
								<label class="card-header">Super User Approvals</label>
								<div class="md-layout-item md-small-size-100 w-100">
									<md-checkbox class="approval-request" v-on:change="validateSuperUser('request')" v-model="suApprovalRequest">Approve Requests</md-checkbox>
								</div>
								<div class="md-layout-item md-small-size-100 w-100">
									<md-checkbox class="approval-response" v-on:change="validateSuperUser('response')" v-model="suApprovalResponse">Approve Responses</md-checkbox>
								</div>
							</div>
							<div class="md-layout-item md-medium-size-40 m-left-5 m-top-20">
								<label class="card-header">Super User Alerts</label>
								<div class="md-layout-item md-small-size-100 w-100">
									<md-checkbox class="approval-request" v-on:change="validateSuperUser('altRequest')" v-model="suAlert.request">Community administrator approves requests</md-checkbox>
								</div>
								<div class="md-layout-item md-small-size-100 w-100">
									<md-checkbox class="approval-response" v-on:change="validateSuperUser('altResponse')" v-model="suAlert.response">Community administrator approves responses</md-checkbox>
								</div>
								<div class="md-layout-item md-small-size-100 w-100">
									<md-checkbox class="approval-response" v-on:change="validateSuperUser('altNoResponse')" v-model="suAlert.noResponse">No response daily alert</md-checkbox>
								</div>
								<div class="md-layout-item md-small-size-100 w-100">
									<md-checkbox class="approval-response" v-on:change="validateSuperUser('altFeedback')" v-model="suAlert.feedback">Feedback of 4 or less</md-checkbox>
								</div>
							</div>
							<div class="md-layout-item md-medium-size-40 m-left-5 m-top-20">
								<label class="card-header">Super User Management</label>
								<div class="md-layout-item md-small-size-100 w-100">
									<md-checkbox class="approval-request" v-on:change="validateSuperUser('mgmtRequest')" v-model="mgmtRequest">Approve Requests</md-checkbox>
								</div>
								<div class="md-layout-item md-small-size-100 w-100">
									<md-checkbox class="approval-response" v-on:change="validateSuperUser('mgmtResponse')" v-model="mgmtResponse">Approve Responses</md-checkbox>
								</div>
							</div>
							<md-button type="submit" class="md-raised md-round md-accent m-top-20">
								{{saveSiteStatusText}}
							</md-button>
						</form>
					</md-card-content>
		        </md-card-expand-content>
		      </md-card-expand>
		    </md-card>
			<!-- interact -->
		</div>
		<div class="box mt-10">
			<md-card>
			    <md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5"><div @click="expandchannel('communitySetting')">Settings</div></md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="card-content">
							<div :class="{ opened: opened.includes('communitySetting') }" v-show="opened.includes('communitySetting')">
							<form @submit.prevent="saveCommunitySetting('form-2')" data-vv-scope="form-2">
								<md-field class="create-community m-left-5">
									<label class="card-header">Community Name:</label>
									<md-input v-model="community.name" name="community name" v-validate="'required'" placeholder="Community Name" @input="community.name = sanitizeInput($event)" ></md-input>
								</md-field>
									<p class="error m-left-5" v-show="errors.has('form-2.community name')">{{errors.first('form-2.community name')}}</p>
								<md-field class="create-community m-left-5">
									<label class="card-header fs-12">Community Code:</label>
									<md-input v-model="community.code" name="community code" v-validate="'required'" placeholder="Community Code" @input="community.code = sanitizeInput($event)" ></md-input>
									<!-- <div class="mt-5">{{community.code}}</div> -->
								</md-field>
								<md-field class="create-community m-left-5">
									<label class="card-header fs-12">SFTP Username:</label>
									<md-input v-model="community.sftpUser" name="SFTP User" placeholder="SFTP Username" @input="community.sftpUser = sanitizeInput($event)" ></md-input>
								</md-field>
								<md-field class="create-community m-left-5">
									<label class="card-header fs-12">SFTP Password:</label>
									<md-input v-model="community.sftpPwd" name="SFTP Password" placeholder="SFTP Password" @input="community.sftpPwd = sanitizeInput($event)" ></md-input>
								</md-field>
								<md-checkbox v-model="community.sftpAutomated" class="m-left-5 card-header md-layout">Automate Processing of SFTP Uploads</md-checkbox>
								<md-field class="create-community m-left-5">
									<label class="card-header fs-12">Salesforce Organization ID:</label>
									<md-input v-model="community.salesforceOrgId" name="Salesforce Org ID" placeholder="Salesforce Organization ID"></md-input>
								</md-field>
									<p class="error m-left-5" v-show="errors.has('form-2.community code')">{{errors.first('form-2.community code')}}</p>
								<md-field class="m-left-5">
									<label class="card-header">Community Timezone:</label>
									<md-input v-model="community.timezone" placeholder="Community Timezone" @input="community.timezone = sanitizeInput($event)" ></md-input>
								</md-field>
								<div class="form-group m-left-5">
								  <label class="card-header">
								    Location Information
								    <img src="../assets/tool_tip.svg" height="12" alt="tooltip" class="ml-2" />
								    <md-tooltip md-direction="right" class="tool-tip-right">Location data required to display Google Map in the Dashboard</md-tooltip>
								  </label>
								  <div class="row mb-3 location-fields">
								    <div class="col-md-4">
								      <div class="location-field-wrapper">
								        <label class="location-label">Country</label>
								        <div class="location-select-wrapper">
								          <select v-model="selectedCountry" class="location-select" @change="onCountryChange">
								            <option value="">Select Country</option>
								            <option v-for="country in countries" :key="country.code" :value="country">
								              {{ country.name }}
								            </option>
								          </select>
								        </div>
								      </div>
								    </div>
								    <div class="col-md-4">
								      <div class="location-field-wrapper">
								        <label class="location-label">State/Province</label>
								        <div class="location-select-wrapper">
								          <select v-model="selectedState" class="location-select" :disabled="!selectedCountry">
								            <option value="">Select State</option>
								            <option v-for="state in states" :key="state" :value="state">
								              {{ state }}
								            </option>
								          </select>
								        </div>
								      </div>
								    </div>
								    <div class="col-md-4">
								      <div class="location-field-wrapper">
								        <label class="location-label">City</label>
								        <input type="text" v-model="city" class="location-input" placeholder="Enter City">
								      </div>
								    </div>
								  </div>
								</div>
								<div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 m-left-5">
									<div class="md-layout-item md-size-35">
										<md-field>
											<label for="communityPortal">
												Update Profile destination
												<img src="../assets/tool_tip.svg" height="12" alt="tooltip" class="ml-2" />
												<md-tooltip md-direction="right" class="tool-tip-right">Choose where members should update their profile data.</md-tooltip>
											</label>
											<md-select v-model="community.communityPortal" name="communityPortal" placeholder="Update Profile destination" id="communityPortal">
												<md-option value="protopia">Protopia</md-option>
												<md-option value="customer">Customer</md-option>
												<md-option value="linkedin">LinkedIn</md-option>
											</md-select>
										</md-field>
									</div>
								</div>
								<div class="md-layout md-gutter" v-if="community.communityPortal == 'linkedin'">
			            			<div class="md-layout-item md-small-size-60 m-left-5">
										<md-field class="create-community">
											<label class="card-header">Client ID:</label>
											<md-input v-model="linkedinCredentials.clientId" v-validate="{ required: true}" name="linkedInClientId" placeholder='Client ID' @input="linkedinCredentials.clientId = sanitizeInput($event)" ></md-input>
										</md-field>
										<p class="error" v-show="errors.has('form-2.linkedInClientId')">{{errors.first('form-2.linkedInClientId')}}</p>
									</div>
									<div class="md-layout-item md-small-size-60 m-left-5">
										<md-field class="create-community">
											<label class="card-header">Client Secret:</label>
											<md-input v-model="linkedinCredentials.clientSecret" v-validate="{ required: true}" name="linkedInClientSecret" placeholder='Client Secret'  @input="linkedinCredentials.clientId = sanitizeInput($event)"></md-input>
										</md-field>
										<p class="error" v-show="errors.has('form-2.linkedInClientSecret')">{{errors.first('form-2.linkedInClientSecret')}}</p>
									</div>
								</div>
								<div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 m-left-5">
									<div class="md-layout-item md-size-35">
										<md-field class="linkedInProfile">
											<label for="profileLink">Profile Link?</label>
											<md-select v-model="community.profileLink" name="profileLink" placeholder="Profile Link" id="profileLink">
												<md-option value="none">None</md-option>
												<md-option value="customerPortal">Customer Portal</md-option>
												<md-option value="linkedInProfile">LinkedIn Profile</md-option>
											</md-select>
										</md-field>
									</div>
								</div>
								<div class="md-layout md-gutter md-field">
			            			<div class="md-layout-item md-small-size-60 m-left-5">
										<md-field class="create-community">
											<label class="card-header">Community Site:</label>
											<md-input v-model="community.communitySite"  v-validate="{ required: community.communityPortal == 'customer' ? true: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }" name="communitySite" placeholder='Community Site URL'  @input="community.communitySite = sanitizeUrl($event)"></md-input>
											<span class="md-helper-text"><strong>Note:</strong> Community site URL for i.e https://www.example.com</span>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100">
										<md-checkbox v-model="community.syncEnabled">{{changeSyncText}}</md-checkbox>
									</div>
								</div>
								<p class="error m-left-5" v-if="errors.has('form-2.communitySite')">{{errors.first('form-2.communitySite')}}</p>
								<div class="m-top-40 m-left-5">
									<md-field class="create-community" :class="{ 'md-has-value': !!community.programPageUrl }">
										<label class="card-header">
											Program Page URL
											<img src="../assets/tool_tip.svg" height="12" alt="tooltip" class="ml-2" />
											<md-tooltip md-direction="right" class="tool-tip-right">Scopes GA data to this community</md-tooltip>
										</label>
										<md-input v-model="community.programPageUrl" v-validate="{ required: true, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }" name="programPageUrl" placeholder="https://xxx.protopia.co" @input="community.programPageUrl = ensureHttpsScheme(sanitizeUrl($event))"></md-input>
									</md-field>
								</div>
								<p class="error m-left-5" v-if="errors.has('form-2.programPageUrl')">{{errors.first('form-2.programPageUrl')}}</p>
								<div class="m-top-40 m-left-5">
									<md-field class="create-community">
										<label class="card-header">
											Google Analytics Property ID
											<img src="../assets/tool_tip.svg" height="12" alt="tooltip" class="ml-2" />
											<md-tooltip md-direction="right" class="tool-tip-right">GA Property ID to display Site Visitors in Dashboard</md-tooltip>
										</label>
										<md-input v-model="community.propertyID" name="propertyID" v-validate="'numeric'" placeholder="Property ID"></md-input>
									</md-field>
								</div>
           						<!-- <md-field class="create-community m-left-5">
									<label class="card-header">Sendgrid Api Key:</label>
									<md-input v-model="community.sendgrid.token" name="sendgrid api key" v-validate="'required'" placeholder="Sendgrid Api Key"  @input="community.sendgrid.token= sanitizeInput($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-show="errors.has('form-2.sendgrid api key')">{{errors.first('form-2.sendgrid api key')}}</p> -->
								<div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 m-left-5">
									<div class="md-layout-item md-size-35">
										<md-field>
											<label for="emailFormat">Email Format</label>
											<md-select v-model="community.emailFormat" name="emailFormat" placeholder="Email Format" id="emailFormat">
												<md-option value="html">Html</md-option>
												<md-option value="text">Text</md-option>
											</md-select>
										</md-field>
									</div>
								</div>
								<md-field class="m-left-5">
									<label class="card-header">Email Sender Name:</label>
									<md-input v-model="community.sender.name" name="sender name" placeholder="Email Sender Name"  @input="community.sender.name = sanitizeInput($event)"></md-input>
								</md-field>
								<md-field class="create-community m-left-5">
									<label class="card-header">Email Sender Address:</label>
									<md-input v-model="community.sender.address" name="sender address" v-validate="'email'" placeholder="Email Sender Address"  @input="community.sender.address = sanitizeInput($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-show="errors.has('form-2.sender address')">{{errors.first('form-2.sender address')}}</p>
								<div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 m-left-5">
									<div class="md-layout-item md-size-35">
										<md-field>
											<label for="mapAdviser">Map Advisers</label>
											<md-select v-model="mapAdviser" multiple name="mapAdviser" placeholder="Map Advisers" id="mapAdviser">
												<md-option value="Student">Student</md-option>
												<md-option value="Alum">Alum</md-option>
												<md-option value="Alumni">Alumni</md-option>
												<md-option value="Mentor">Mentor</md-option>
												<md-option value="Entrepreneur">Entrepreneur</md-option>
											</md-select>
										</md-field>
									</div>
								</div>
								<div v-if="isSenderEmailAddress">
									<md-checkbox v-model="community.is_sender_email_address" class="m-left-5 card-header">Use member email address as sender?</md-checkbox>
								</div>
								<div>
									<md-checkbox v-model="community.is_sms_enable" class="m-left-5 card-header">Enable SMS</md-checkbox>
								</div>
								<div class="md-layout-item m-left-5" v-if="community.is_sms_enable">
									<md-field class="create-community md-small-size-100">
										<md-input v-model="community.twilio_phone_number" name="twilio_phone_number" v-validate= "{ required: true, regex: /^\+(?:[0-9] ?){11,11}$/ }" placeholder="Originating Phone Number" @input="community.twilio_phone_number = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error" v-show="errors.has('form-2.twilio_phone_number')">{{errors.first('form-2.twilio_phone_number')}}</p>
								</div>
								<div>
									<md-checkbox v-model="community.member_only_access" class="m-left-5 card-header">Members – only access</md-checkbox>
								</div>
								<div>
									<md-checkbox v-model="community.isAllMembersAreAdvisers" class="m-left-5 card-header md-layout">All members are advisors</md-checkbox>
								</div>
								<md-button type="submit" class="md-raised md-round md-accent mt-20">{{ saveText }}</md-button>
								<md-button class="md-raised md-red mt-20" @click="active = true">Delete Community</md-button>
								<md-button class="md-raised md-yellow mt-20" @click="createCommunityCopy()" :disabled=isDisabled>{{ copyText }}</md-button>
							</form>
							</div>
						</md-card-content>
	        		</md-card-expand-content>
		      	</md-card-expand>
			</md-card>
		</div>
		<div class="box mt-10">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5"><div @click="expandchannel('6')">Administrators</div></md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="card-content">
							<div :class="{ opened: opened.includes('6') }" v-show="opened.includes('6')">
								<div class="m-left-5">
									<div :class="{'vue-empty': administrators.length <= 0 ? true : false}">
										<md-subheader class="card-header community-subheader">Community Administrators
											<div class="m-left-10">
												<member-picker v-on:chosen="addAdministrators" v-if="administrators.length < 30" :selectionType="administrators" section="administrators" :community="$route.params.community_id">Choose Administrators...</member-picker>
											</div>
											<p class="empty-admin-state"><small v-show="!administrators.length">Please select administrators</small></p>
										</md-subheader>
										<md-table v-if="administrators.length" class="admin-table ">
											<md-table-row>
												<md-table-head class="card-header">Name</md-table-head>
												<md-table-head class="card-header">Approvals Email</md-table-head>
												<md-table-head class="card-header">Escalation Email</md-table-head>
												<md-table-head class="card-header">Reports Email</md-table-head>
												<md-table-head class="card-header">Members Email</md-table-head>
												<md-table-head class="card-header">Alert - Request</md-table-head>
												<md-table-head class="card-header">Alert - Response</md-table-head>
												<md-table-head class="card-header">Alert - Donor</md-table-head>
												<md-table-head class="card-header">Alert - Feedback</md-table-head>
												<md-table-head class="card-header">Alert - Referral</md-table-head>
												<md-table-head class="card-header">Alert - Unsubscribe</md-table-head>
												<md-table-head class="card-header">Alert - Profile Update</md-table-head>
												<md-table-head class="card-header">Alert - No Follow-Up</md-table-head>
												<md-table-head class="card-header">Actions</md-table-head>
											</md-table-row>
											<template v-for="administrator in administrators">
												<admin-list v-if="administrator && administrator.memberId && administrator.memberId._id" :member="administrator.memberId" :settings="administrator" :key="'username_'+administrator.memberId._id" v-on:remove="removeAdministrator" dataType="administrator">Administrator goes here...</admin-list>
											</template>
										</md-table>
									</div>
								</div>
							</div>
						</md-card-content>
	        		</md-card-expand-content>
		      	</md-card-expand>
			</md-card>
		</div>
		<div class="box mt-10 circle-section">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="left">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5">Circles</md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="card-content">
							<circles :community_id="community_id"></circles>
						</md-card-content>
					</md-card-expand-content>
		    	</md-card-expand>
			</md-card>
		</div>
		<div class="box mt-10">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button"><div @click="expandchannel('rules')">Rules</div></md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="rules card-content">
							<form @submit.prevent="rulesValidate('form-rules')" @change="saveRulesText='Save'" autocomplete="off" data-vv-scope="form-rules" class= "form-rules">
								<md-field class="create-rule m-left-5">
									<label class="card-header">Minimum Matching Threshold for Automated Matching (in %) (Hermes only)</label>
									<md-input v-model="matchingThreshold" name="matching_threshold" v-validate="'required|min_value:1|max_value:100'"  @input="matchingThreshold = sanitizeInput($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-show="errors.has('form-rules.matching_threshold')">{{errors.first('form-rules.matching_threshold')}}</p>
								<div class=" md-layout-item md-medium-size-20">
									<md-field class="m-left-5 create-rule">
										<label class="card-header">Advisor Minimum (match this many advisors initially):</label>
										<md-select v-model="minimum_advisors_ratio" name="minimum_advisors_ratio" v-validate="'required'" placeholder="minimum_advisors_ratio"  >
											<md-option v-for="n in ratio" :key="n" :value="n">{{n}}</md-option>
										</md-select>
									</md-field>
								</div>
								<p class="error m-left-5" v-show="errors.has('form-rules.minimum_advisors_ratio')">{{errors.first('form-rules.minimum_advisors_ratio')}}</p>
								<div class="md-layout-item md-medium-size-20">
									<md-field class="m-left-5 create-rule">
										<label class="card-header">Response Minimum (number of responses needed before stopping auto-matching):</label>
										<md-select v-model="minimum_responses_ratio" name="minimum_responses_ratio"  v-validate="'required'" >
											<md-option v-for="n in ratio" :key="n" :value="n">{{n}}</md-option>
										</md-select>
									</md-field>
								</div>
								<p class="error m-left-5" v-show="errors.has('form-rules.minimum_responses_ratio')">{{errors.first('form-rules.minimum_responses_ratio')}}</p>
								<div class=" md-layout-item md-medium-size-20">
									<md-field class="m-left-5 create-rule">
										<label class="card-header">Days (wait this many days before auto-matching more advisors):</label>
										<md-select v-model="days" name="days" v-validate="'required'" placeholder="days" >
											<md-option v-for="n in ratio" :key="n" :value="n">{{n}}</md-option>
										</md-select>
									</md-field>
								</div>
								<p class="error m-left-5" v-show="errors.has('form-rules.days')">{{errors.first('form-rules.days')}}</p>
								<div class=" md-layout-item md-medium-size-20">
									<md-field class="m-left-5 create-rule">
										<label class="card-header">Minimum Advisors (match this many additional advisors if not responded to yet):</label>
										<md-select v-model="minimum_advisors" name="minimum_advisors" v-validate="`required|max_value:${maximum_advisors}`" placeholder="minimum_advisors" >
											<md-option v-for="n in advisorCount" :key="n" :value="n">{{n}}</md-option>
										</md-select>
									</md-field>
								</div>
								<p class="error m-left-5" v-show="errors.has('form-rules.minimum_advisors')">{{errors.first('form-rules.minimum_advisors')}}</p>
								<div class=" md-layout-item md-medium-size-20">
									<md-field class="m-left-5 create-rule">
										<label class="card-header">Maximum Advisors (total number of advisors that can be matched to a request):</label>
										<md-select v-model="maximum_advisors" name="maximum_advisors" v-validate="'required'" placeholder="maximum_advisors" >
											<md-option v-for="n in advisorCount" :key="n" :value="n">{{n}}</md-option>
										</md-select>
									</md-field>
								</div>
								<p class="error m-left-5" v-show="errors.has('form-rules.maximum_advisors')">{{errors.first('form-rules.maximum_advisors')}}</p>
								<!-- TEMPORARY REMOVED AS PER CLIENT COMMENT -->
								<!-- <div class=" md-layout-item md-medium-size-20">
									<md-field class="m-left-5 create-rule">
										<label class="card-header">Request Received Reduction (in %)</label>
										<md-input v-validate="'decimal|min_value:0|max_value:100'" v-model.trim="community.rules.requestReceivedReduction" name="requestReceivedReduction" placeholder="Request Received Reduction (in %)"></md-input>
									</md-field>
								</div>
								<p class="error m-left-5" v-show="errors.has('requestReceivedReduction')">{{errors.first('requestReceivedReduction')}}</p>
								<div class=" md-layout-item md-medium-size-20">
									<md-field class="m-left-5 create-rule">
										<label class="card-header">Response Shared Discount (in %)</label>
										<md-input v-validate="'decimal|min_value:0|max_value:100'" v-model.trim="community.rules.responseSharedDiscount" name="responseSharedDiscount" placeholder="Response Shared Discount (in %)"></md-input>
									</md-field>
								</div>
								<p class="error m-left-5" v-show="errors.has('responseSharedDiscount')">{{errors.first('responseSharedDiscount')}}</p> -->

								<div class="md-layout-item md-medium-size-40">
									<label class="card-header">Gemini:</label>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox v-model="community.rules.geminiMatching" class="approval-request" >Use Gemini to automatically match advisors</md-checkbox>
									</div>

									<div class=" md-layout-item md-medium-size-20">
										<md-field class="m-left-5 create-rule">
											<label class="card-header">Minimum Terms in Request:</label>
											<md-select v-model="community.rules.geminiMinimumTerms" name="geminiMinimumTerms" v-validate="'required'" placeholder="minimum terms" >
												<md-option v-for="n in advisorCount" :key="n" :value="n">{{n}}</md-option>
											</md-select>
										</md-field>
									</div>

								</div>

								<div class="md-layout-item md-medium-size-40" style="margin-top: 18px;">
								<label class="card-header">Approvals:</label>
								<div style="display: flex; gap: 8px; align-items: flex-start;">
									<!-- First Column -->
									<div style="flex: 1 1 0; max-width: 300px;">
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox class="approval-request" v-model="community.rules.approvalRequest">
										Approval for requesters
										</md-checkbox>
									</div>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox class="approval-response" v-model="community.rules.approvalResponse">
										Approval for respondents
										</md-checkbox>
									</div>
									</div>
									<!-- Second Column -->
									<div style="flex: 1 1 0; max-width: 300px;">
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox class="approval-response" v-model="community.rules.AIapprovalRequest">
										AI approvals for requests
										</md-checkbox>
									</div>
									</div>
								</div>
								</div>
								<p class="error m-left-5"></p>
								<div class="md-layout-item md-medium-size-40">
									<label class="card-header">Reminders:</label>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox class="approval-request" v-model="community.rules.firstRequestReminder" >Request Reminder 1</md-checkbox>
									</div>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox class="approval-response" v-model="community.rules.secondRequestReminder" >Request Reminder 2</md-checkbox>
									</div>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox class="approval-response" v-model="community.rules.feedbackReminder" >Feedback Reminder</md-checkbox>
									</div>
								</div>
								<p class="error m-left-5"></p>
								<div class="md-layout-item md-medium-size-40">
									<label class="card-header">Ask Again Emails</label>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox v-model="askAgainFeedbackFrequency.low" class="approval-response" >Feedback Low</md-checkbox>
									</div>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox v-model="askAgainFeedbackFrequency.medium" class="approval-response" >Feedback Medium</md-checkbox>
									</div>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox v-model="askAgainFeedbackFrequency.high" class="approval-response" >Feedback High</md-checkbox>
									</div>
								</div>
								<p class="error m-left-5"></p>
								<div class="md-layout-item">
									<label class="card-header">Engagement Emails</label>
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox v-model="community.rules.memberEngagementEmail" class="approval-response memberEngagementEmail" >Member Request Reminder <span>(Reminder after 14 days that we're still recruiting advisors)</span></md-checkbox>
									</div>
								</div>
								<div class="md-layout-item">
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox v-model="community.rules.feedbackFrequencyToRequest" class="approval-response memberEngagementEmail" >Use Frequency to limit all requests.</md-checkbox>
									</div>
								</div>
								<div class="md-layout-item">
									<div class="md-layout-item md-small-size-100 w-100">
										<md-checkbox v-model="community.rules.automaticallyCloseRequest" class="approval-response memberEngagementEmail" >Automatically close requests</md-checkbox>
									</div>
								</div>
								<div class="md-layout-item">
									<div class="md-layout-item md-small-size-100 w-100">
										<ul class="list-inline">
											<li class="list-inlne-item">
												<md-checkbox v-model="community.rules.volunteerEscalations" class="approval-response memberEngagementEmail" >Volunteer Escalations</md-checkbox>
											</li>
											<li class="list-inlne-item">
												<md-field class="m-left-5 create-rule">
													<md-input v-model="community.rules.superEscalatedAdvisors" name="superEscalatedAdvisors" v-validate="'required|min_value:1|max_value:1000'"  @input="community.rules.superEscalatedAdvisors = sanitizeInput($event)"></md-input>
												</md-field>
											</li>
										</ul>
									</div>
								</div>
								<div class="md-layout-item">
									<div class="md-layout-item md-small-size-100 w-100">
										<ul class="list-inline">
											<li class="list-inlne-item">
												<md-checkbox v-model="community.rules.browserNewsletter" class="approval-response memberEngagementEmail" >Volunteer Digest</md-checkbox>
											</li>
											<li class="list-inline-item">
												<md-field class="m-left-5 create-rule">
													<md-select v-model="community.rules.browserNewsletterDay" class="inline-select" placeholder="Select Day">
													<md-option value="Monday">Monday</md-option>
													<md-option value="Tuesday">Tuesday</md-option>
													<md-option value="Wednesday">Wednesday</md-option>
													<md-option value="Thursday">Thursday</md-option>
													<md-option value="Friday">Friday</md-option>
													<md-option value="Saturday">Saturday</md-option>
													<md-option value="Sunday">Sunday</md-option>
													</md-select>
												</md-field>
											</li>
										</ul>
									</div>
								</div>
								<p class="error m-left-5"></p>
								<div class="md-layout-item md-medium-size-20 mt-15px">
									<div class="md-layout-item md-small-size-100 w-100">
									<label class="card-header">Workflows</label>
									</div>
									<ul class="list-inline">
										<li class="list-inline-item">
											<md-field class="m-left-5 create-rule">
												<label class="card-header">Request Escalation (Days):</label>
												<md-select v-model="community.rules.workflow.requestEscalation"
													name="requestEscalation"
													v-validate="'required|integer|min_value:1|max_value:30'"
													placeholder="Select escalation days">
													<md-option v-for="n in 30" :key="n" :value="n">{{ n }}</md-option>
												</md-select>
											</md-field>
										</li>
									</ul>
									<ul class="list-inline">
										<li class="list-inlne-item">
											<md-checkbox v-model="community.rules.workflow.menteeReminder"
												class="menteeReminder">Mentee Reminder</md-checkbox>
										</li>
										<li class="list-inline-item">
											<md-field class="m-left-5 create-rule">
												<md-select v-model="community.rules.workflow.type" name="type"
													placeholder="Reminder Type">
													<md-option value="Weekly">Weekly</md-option>
													<md-option value="Monthly">Monthly</md-option>
												</md-select>
											</md-field>
										</li>
									</ul>
									<ul class="list-inline">
										<li class="list-inlne-item">
											<md-checkbox v-model="community.rules.workflow.moduleResources"
												class="moduleResources">Module - Resources</md-checkbox>
										</li>
										<li class="list-inline-item">
											<md-field class="m-left-5 create-rule">
												<label class="card-header">Max Resources to Include:</label>
												<md-select v-model="community.rules.workflow.maxResources"
													name="maxResources"
													v-validate="'required|integer|min_value:max_value:10'"
													placeholder="Select max resources">
													<md-option v-for="n in 10" :key="n" :value="n">{{ n }}</md-option>
												</md-select>
											</md-field>
										</li>
									</ul>

								</div>
								<div class="md-layout-item">
										<label class="card-header">Semester Summary</label>
										<div class="md-layout-item md-small-size-100 w-100">
											<md-checkbox v-model="semesterSummary.member" class="approval-response memberEngagementEmail">Members</md-checkbox>
										</div>
									</div>
									<SemesterDateBlock
										ref="dateBlock1"
										label="Date 1"
										:date.sync="semesterSummary.date1"
										:range.sync="semesterSummary.range1"
									/>
									<SemesterDateBlock
										ref="dateBlock2"
										label="Date 2"
										:date.sync="semesterSummary.date2"
										:range.sync="semesterSummary.range2"
									/>
									<SemesterDateBlock
										ref="dateBlock3"
										label="Date 3"
										:date.sync="semesterSummary.date3"
										:range.sync="semesterSummary.range3"
									/>
									<SemesterDateBlock
										ref="dateBlock4"
										label="Date 4"
										:date.sync="semesterSummary.date4"
										:range.sync="semesterSummary.range4"
									/>
								<md-button class="mt-20 md-raised md-round md-accent" type="submit">{{ saveRulesText }}</md-button>
							</form>
						</md-card-content>
	        		</md-card-expand-content>
		      	</md-card-expand>
			</md-card>
		</div>

		<!-- Recruiting config (PRD §5.1). -->
		<community-recruiting-config :community="community" />

		<div class="box mt-10">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5"><div @click="expandchannel('7')">Partner Communities</div></md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="custom-checkbox-partner-communities card-content">
							<form @submit.prevent="updatePartnerCommunity()" autocomplete="off" data-vv-scope="form-partner-community" class= "form-partner-community">
								<partner-community-list :pCommunity="communities" :mCommunity="community" dataType="partnerCommunity"></partner-community-list>
							</form>
						</md-card-content>
					</md-card-expand-content>
		    	</md-card-expand>
			</md-card>
		</div>
		<div class="box mt-10" v-if="community.customSettings">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5">Styling</md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="card-content">
							<form @submit.prevent="saveStyle('style-setting')" autocomplete="off" data-vv-scope="style-setting">
								<md-field class="m-left-5">
									<label class="card-header">Community Logo (250 x 50)</label>
									<md-input v-model="community.customSettings.logoURL" placeholder="Logo URL"  @input="community.customSettings.logoURL = sanitizeUrl($event)"></md-input>
								</md-field>
								<md-field class="m-left-5">
									<label class="card-header">Community Favicon (16 x 16)</label>
									<md-input v-model="community.customSettings.faviconURL" placeholder="Logo URL"></md-input>
								</md-field>
								<md-field class="m-left-5">
									<label class="card-header">Community Icon (100 x 100)</label>
									<md-input v-model="community.customSettings.iconURL" placeholder="Icon URL" @input="community.customSettings.iconURL = sanitizeUrl($event)"></md-input>
								</md-field>
								<md-field class="m-left-5">
									<label class="card-header">Organization Logo (150 x 40)</label>
									<md-input v-model="community.customSettings.organizationURL" placeholder="Organization URL"></md-input>
								</md-field>
								<md-field class="m-left-5">
									<label class="card-header">Organization Logo (150 x 40)</label>
									<md-input v-model="community.customSettings.organizationURL" placeholder="Organization URL"></md-input>
								</md-field>
								<md-field class="m-left-5">
									<label class="card-header">Background Color:</label>
									<md-input v-model="community.customSettings.primaryColor" placeholder="Background Color" @input="community.customSettings.primaryColor = sanitizeCss($event)"></md-input>
								</md-field>
								<md-field class="m-left-5">
									<label class="card-header">Text Color:</label>
									<md-input v-model="community.customSettings.secondaryColor" placeholder="Text Color" @input="community.customSettings.secondaryColor = sanitizeCss($event)"></md-input>
								</md-field>
								<md-field class="m-left-5 create-rule">
									<label class="card-header">Primary Button Background Color:</label>
									<md-input v-model="community.customSettings.primaryBtnBgColor" v-validate= "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }" name="primaryBtnBgColor" type="text" placeholder="Primary Button Background Color" @input="community.customSettings.primaryBtnBgColor = sanitizeCss($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-if="errors.has('style-setting.primaryBtnBgColor')">{{errors.first('style-setting.primaryBtnBgColor')}}</p>
								<md-field class="m-left-5 create-rule">
									<label class="card-header">Primary Button Text Color:</label>
									<md-input v-model="community.customSettings.primaryTxtColor" v-validate= "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }" name="primaryTxtColor" type="text" placeholder="Primary Button Text Color" @input="community.customSettings.primaryTxtColor = sanitizeCss($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-if="errors.has('style-setting.primaryTxtColor')">{{errors.first('style-setting.primaryTxtColor')}}</p>
								<md-field class="m-left-5 create-rule">
									<label class="card-header">Secondary Button Background Color:</label>
									<md-input v-model="community.customSettings.secondaryBtnBgColor" v-validate= "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }" name="secondaryBtnBgColor" type="text" placeholder="Secondary Button Background Color" @input="community.customSettings.secondaryBtnBgColor = sanitizeCss($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-if="errors.has('style-setting.secondaryBtnBgColor')">{{errors.first('style-setting.secondaryBtnBgColor')}}</p>
								<md-field class="m-left-5 create-rule">
									<label class="card-header">Secondary Button Text Color:</label>
									<md-input v-model="community.customSettings.secondaryTxtColor" v-validate= "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }" name="secondaryTxtColor" type="text" placeholder="Secondary Button Text Color" @input="community.customSettings.secondaryTxtColor = sanitizeCss($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-if="errors.has('style-setting.secondaryTxtColor')">{{errors.first('style-setting.secondaryTxtColor')}}</p>
								<md-field class="m-left-5 create-rule">
									<label class="card-header">Third Customizable Background Color:</label>
									<md-input v-model="community.customSettings.thirdBtnBgColor" v-validate= "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }" name="thirdBtnBgColor" type="text" placeholder="Third Customizable Button Background Color" @input="community.customSettings.thirdBtnBgColor = sanitizeCss($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-if="errors.has('style-setting.thirdBtnBgColor')">{{errors.first('style-setting.thirdBtnBgColor')}}</p>
								<md-field class="m-left-5 create-rule">
									<label class="card-header">Third Customizable Text Color:</label>
									<md-input v-model="community.customSettings.thirdTxtColor" v-validate= "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }" name="thirdTxtColor" type="text" placeholder="Third Customizable Button Text Color" @input="community.customSettings.thirdTxtColor = sanitizeCss($event)"></md-input>
								</md-field>
								<p class="error m-left-5" v-if="errors.has('style-setting.thirdTxtColor')">{{errors.first('style-setting.thirdTxtColor')}}</p>
								<md-button class="mt-20 md-raised md-round md-accent" type="submit">{{ saveStyleText }}</md-button>
							</form>
						</md-card-content>
					</md-card-expand-content>
		    	</md-card-expand>
			</md-card>
		</div>
		<div class="box mt-10">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5"><div @click="expandchannel('request')">Request</div></md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="card-content">
							<div :class="{ opened: opened.includes('request') }" v-show="opened.includes('request')">
								<div class="row">
									<div class="col-md-12">
										<div class="col-md-4"></div>
										<div class="col-md-4">
											<h4 class="mt-18">Request Form</h4>
										</div>
										<div class="col-md-4">
											<h4 class="mt-18">Bot</h4>
										</div>
									</div>
								</div>
								<form @submit.prevent="addRequestContent('form-content')" @change="requestSaveContentText='save'" data-vv-scope="form-content">
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>First Name</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('firstName')" name="firstNameLabel"  v-validate="'required'" v-model.trim="configureFields.firstName.labelName" @input="configureFields.firstName.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('firstName')" name="firstNameLabel" v-validate="'required'" v-model.trim="configureFields.firstName.chatbotLabelName"  @input="configureFields.firstName.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Last Name</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('lastName')" name="lastNameLabel" v-validate="'required'" v-model.trim="configureFields.lastName.labelName"  @input="configureFields.lastName.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('lastName')" name="lastNameLabel" v-validate="'required'" v-model.trim="configureFields.lastName.chatbotLabelName"  @input="configureFields.lastName.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Email Address</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('emailAddress')"  name="emailAddressLabel"  v-validate="'required'" v-model.trim="configureFields.emailAddress.labelName"  @input="configureFields.emailAddress.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('emailAddress')"  name="emailAddressLabel"  v-validate="'required'" v-model.trim="configureFields.emailAddress.chatbotLabelName"  @input="configureFields.emailAddress.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Subject</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('subject')" name="subjectLabel" v-validate="'required'" v-model.trim="configureFields.subject.labelName"  @input="configureFields.subject.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('subject')" name="subjectLabel" v-validate="'required'" v-model.trim="configureFields.subject.chatbotLabelName" @input="configureFields.subject.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Subject placeholder</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input v-model="requestForm.subjectLine" name="requestForm.subjectLine" placeholder='Request Form - Subject Line' @input="requestForm.subjectLine = sanitizeInput($event)"></md-input>
											</md-field>
											<p class="error m-left-5" v-show="errors.has('form-content.subjectLine')">{{errors.first('form-content.subjectLine')}}</p>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Question</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('question')" name="questionLabel" v-validate="'required'" v-model.trim="configureFields.question.labelName" @input="configureFields.question.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('question')" name="questionLabel" v-validate="'required'" v-model.trim="configureFields.question.chatbotLabelName" @input="configureFields.question.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Question placeholder</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input v-model="requestForm.question" name="requestForm.question" placeholder='Request Form - Question' @input="requestForm.question = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Member Role</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.memberRole.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.memberRole.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('memberRole')"  name="memberRoleLabel"  v-validate="'required'" v-model="configureFields.memberRole.labelName" @input="configureFields.memberRole.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('memberRole')"  name="memberRoleLabel"  v-validate="'required'" v-model="configureFields.memberRole.chatbotLabelName" @input="configureFields.memberRole.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10"></div>
											<div class="col-md-4"></div>
											<div class="col-md-4">
												<label class="mt-18">Values:</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('memberRoleValue')" name="memberRoleValue" v-validate="'required'" v-model="configureFields.memberRole.value" @input="configureFields.memberRole.value = sanitizeInput($event)"></md-input>
											</md-field>
											<p class="error error-custom-position" v-if="memberRoleValue">Options values should not be more than 15.</p>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('chatbotMemberRoleValue')" name="chatbotMemberRoleValue" v-validate="'required'" v-model="configureFields.memberRole.chatbotValue" @input="configureFields.memberRole.chatbotValue = sanitizeInput($event)"></md-input>
											</md-field>
											<p class="error error-custom-position" v-if="chatbotMemberRoleValue">Options values should not be more than 15.</p>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Advice Area</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.adviceArea.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.adviceArea.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('adviceArea')" name="adviceAreaLabel" v-validate="'required'" v-model="configureFields.adviceArea.labelName" @input="configureFields.adviceArea.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('adviceArea')"  name="adviceAreaLabel"  v-validate="'required'" v-model="configureFields.adviceArea.chatbotLabelName" @input="configureFields.adviceArea.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10"></div>
											<div class="col-md-4"></div>
											<div class="col-md-4">
												<label class="mt-18">Values:</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('adviceAreaValue')" name="adviceAreaValue" v-validate="'required'" v-model="configureFields.adviceArea.value" @input="configureFields.adviceArea.value = sanitizeInput($event)"></md-input>
											</md-field>
											<p class="error error-custom-position" v-if="adviceAreaValue">Options values should not be more than 6.</p>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('chatbotAdviceAreaValue')" name="chatbotAdviceAreaValue" v-validate="'required'" v-model="configureFields.adviceArea.chatbotValue" @input="configureFields.adviceArea.chatbotValue = sanitizeInput($event)"></md-input>
											</md-field>
											<p class="error error-custom-position" v-if="chatbotAdviceAreaValue">Options values should not be more than 6.</p>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>College / Program</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.college.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.college.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('collegeLabel')"  name="collegeLabel"  v-validate="'required'" v-model="configureFields.college.labelName" @input="configureFields.college.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('collegeLabel')"  name="collegeLabel"  v-validate="'required'" v-model="configureFields.college.chatbotLabelName" @input="configureFields.college.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>College / Program (Dropdown)</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.college2.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.college2.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('college2Label')"  name="college2Label"  v-validate="'required'" v-model="configureFields.college2.labelName" @input="configureFields.college2.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('college2Label')"  name="college2Label"  v-validate="'required'" v-model="configureFields.college2.chatbotLabelName" @input="configureFields.college2.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10"></div>
											<div class="col-md-4"></div>
											<div class="col-md-4">
												<label class="mt-18">Values:</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('college2Value')" name="college2Value" v-validate="'required'" v-model="configureFields.college2.value" @input="configureFields.college2.value = sanitizeInput($event)"></md-input>
											</md-field>
											<!-- <p class="error error-custom-position" v-if="college2Value">Options values should not be more than 6.</p> -->
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('college2Value')" name="college2Value" v-validate="'required'" v-model="configureFields.college2.chatbotValue" @input="configureFields.college2.chatbotValue = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>

                  <!-- Major (Dropdown) Field -->
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Major (Dropdown)</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.major.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.major.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('majorLabel')"  name="majorLabel"  v-validate="'required'" v-model="configureFields.major.labelName" @input="configureFields.major.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('majorLabel')"  name="majorLabel"  v-validate="'required'" v-model="configureFields.major.chatbotLabelName" @input="configureFields.major.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10"></div>
											<div class="col-md-4"></div>
											<div class="col-md-4">
												<label class="mt-18">Values:</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('majorValue')" name="majorValue" v-validate="'required'" v-model="configureFields.major.value" @input="configureFields.major.value = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('majorValue')" name="majorValue" v-validate="'required'" v-model="configureFields.major.chatbotValue" @input="configureFields.major.chatbotValue = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>

									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Class Year</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.classYear.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.classYear.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('classYearLabel')"  name="classYearLabel"  v-validate="'required'" v-model="configureFields.classYear.labelName" @input="configureFields.classYear.labelName = sanitizeInput($event)" ></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('classYearLabel')"  name="classYearLabel"  v-validate="'required'" v-model="configureFields.classYear.chatbotLabelName" @input="configureFields.classYear.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Class Year (Dropdown)</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.classYear2.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.classYear2.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('classYear2Label')" name="classYear2Label"  v-validate="'required'" v-model="configureFields.classYear2.labelName" @input="configureFields.classYear2.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('classYear2Label')"  name="classYear2Label"  v-validate="'required'" v-model="configureFields.classYear2.chatbotLabelName" @input="configureFields.classYear2.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10"></div>
											<div class="col-md-4"></div>
											<div class="col-md-4">
												<label class="mt-18">Values:</label>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('classYear2Value')" name="classYear2Value" v-validate="'required'" v-model="configureFields.classYear2.value" @input="configureFields.classYear2.value = sanitizeInput($event)" ></md-input>
											</md-field>
											<!-- <p class="error error-custom-position" v-if="classYear2Value">Options values should not be more than 6.</p> -->
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('classYear2Value')" name="classYear2Value" v-validate="'required'" v-model="configureFields.classYear2.chatbotValue" @input="configureFields.classYear2.chatbotValue = sanitizeInput($event)"></md-input>
											</md-field>
											<!-- <p class="error error-custom-position" v-if="classYear2Value">Options values should not be more than 6.</p> -->
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Title</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.title.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.title.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('titleLabel')"  name="titleLabel"  v-validate="'required'" v-model="configureFields.title.labelName" @input="configureFields.title.labelName = sanitizeInput($event)" ></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('titleLabel')"  name="titleLabel"  v-validate="'required'" v-model="configureFields.title.chatbotLabelName"  @input="configureFields.title.chatbotLabelName = sanitizeInput($event)" ></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Organization</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.organization.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.organization.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('organizationLabel')"  name="organizationLabel"  v-validate="'required'" v-model="configureFields.organization.labelName" @input="configureFields.organization.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('organizationLabel')"  name="organizationLabel"  v-validate="'required'" v-model="configureFields.organization.chatbotLabelName" @input="configureFields.organization.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Student ID</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.studentId.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.studentId.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('studentLabel')"  name="studentIdLabel"  v-validate="'required'" v-model="configureFields.studentId.labelName" @input="configureFields.studentId.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('studentLabel')"  name="studentIdLabel"  v-validate="'required'" v-model="configureFields.studentId.chatbotLabelName" @input="configureFields.studentId.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Due Date</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.dueDate.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.dueDate.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('dueDateLabel')"  name="dueDateLabel"  v-validate="'required'" v-model="configureFields.dueDate.labelName" @input="configureFields.dueDate.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('dueDateLabel')"  name="dueDateLabel"  v-validate="'required'" v-model="configureFields.dueDate.chatbotLabelName" @input="configureFields.dueDate.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>LinkedIn profile</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.linkedInProfile.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.linkedInProfile.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('linkedInProfileLabel')"  name="linkedInProfileLabel"  v-validate="'required'" v-model="configureFields.linkedInProfile.labelName" @input="configureFields.linkedInProfile.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('linkedInProfileLabel')"  name="linkedInProfileLabel"  v-validate="'required'" v-model="configureFields.linkedInProfile.chatbotLabelName" @input="configureFields.linkedInProfile.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Phone Number</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.phoneNumber.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.phoneNumber.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('phoneNumberLabel')"  name="phoneNumberLabel"  v-validate="'required'" v-model="configureFields.phoneNumber.labelName" @input="configureFields.phoneNumber.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
										<div class="col-md-4">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('phoneNumberLabel')"  name="phoneNumberLabel"  v-validate="'required'" v-model="configureFields.phoneNumber.chatbotLabelName" @input="configureFields.phoneNumber.chatbotLabelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Referrer</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.referrer.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.referrer.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-8">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('sourceLabel')"  name="sourceLabel"  v-validate="'required'" v-model="configureFields.referrer.labelName" @input="configureFields.referrer.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Referrer (Dropdown)</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.referrer2.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.referrer2.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-8">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('referrer2Label')"  name="referrer2Label"  v-validate="'required'" v-model="configureFields.referrer2.labelName" @input="configureFields.referrer2.labelName = sanitizeInput($event)"></md-input>
											</md-field>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10"></div>
											<div class="col-md-4"></div>
											<div class="col-md-4">
												<label class="mt-18">Values:</label>
											</div>
										</div>
										<div class="col-md-8">
											<md-field class="mt--6">
												<md-input @blur="labelValidate('referrer2Value')" name="referrer2Value" v-validate="'required'" v-model="configureFields.referrer2.value" @input="configureFields.referrer2.value = sanitizeInput($event)"></md-input>
											</md-field>
											<!-- <p class="error error-custom-position" v-if="referrer2Value">Options values should not be more than 6.</p> -->
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Disclaimer</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.disclaimer.include">Include</md-checkbox>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.disclaimer.require">Required</md-checkbox>
											</div>
										</div>
										<div class="col-md-4 custom-textarea">
											<md-field class="mt--6">
												<md-textarea @blur="labelValidate('disclaimerLabel')" v-validate.continues="'max:2000'" :maxlength="2000" name="disclaimerLabel"
												v-model="configureFields.disclaimer.labelName" placeholder="Enter disclaimer here" @input="configureFields.disclaimer.labelName = sanitizeInput($event)"></md-textarea>
											</md-field>
										</div>
										<div class="col-md-4 custom-textarea">
											<md-field class="mt--6">
												<md-textarea @blur="labelValidate('disclaimerLabel')" v-validate.continues="'max:2000'" :maxlength="2000" name="disclaimerLabel"
												v-model="configureFields.disclaimer.chatbotLabelName" placeholder="Enter disclaimer here" @input="configureFields.disclaimer.chatbotLabelName = sanitizeInput($event)"></md-textarea>
											</md-field>
										</div>
									</div>
									<hr class="request-hr m-left-5 ">
									<div class="row">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Interest</label>
											</div>
											<div class="col-md-4">
												<md-checkbox v-model="configureFields.interest.include">Include</md-checkbox>
											</div>
										</div>
										<div class="col-md-4 custom-textarea">
											<md-field class="mt--6">
												<md-textarea @blur="labelValidate('description')" name="description"
												v-model="configureFields.interest.description" class="community-interest-description" placeholder="Enter interest description" rows="5" @input="configureFields.interest.description = sanitizeInput($event)"></md-textarea>
											</md-field>
										</div>
									</div>
									<div class="row mt-30">
										<div class="col-md-4">
											<div class="col-md-4 mt-10">
												<label>Profile Updates</label>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 col-sm-6">
											<div class="col-md-1 mt-15">
												Interests
											</div>
											<div class="col-md-2">
												<md-field class="mt--6 mb-0">
													<md-select v-model="configureFields.profileUpdateInterest" name="profileUpdateInterest" placeholder="Interests" @md-selected="changeProfileUpdate(configureFields.profileUpdateInterest,'interests')" >
														<md-option v-for="(value,index) in defaultProfileUpdateList" :key="index" :value="index">{{value}}</md-option>
													</md-select>
												</md-field>
											</div>
										</div>
										<div class="col-md-12 col-sm-6">
											<div class="col-md-1 mt-15">
												Occupation
											</div>
											<div class="col-md-2">
												<md-field class="mt--6 mb-0">
													<md-select v-model="configureFields.profileUpdateOccupation" name="profileUpdateOccupation" @md-selected="changeProfileUpdate(configureFields.profileUpdateOccupation,'occupation')" placeholder="Occupation" >
														<md-option v-for="(value,index) in defaultProfileUpdateList" :key="index" :value="index">{{value}}</md-option>
													</md-select>
												</md-field>
											</div>
										</div>
										<div class="col-md-12 col-sm-6">
											<div class="col-md-1 mt-15">
												Geography
											</div>
											<div class="col-md-2">
												<md-field class="mt--6 mb-0">
													<md-select v-model="configureFields.profileUpdateGeography" name="profileUpdateGeography" @md-selected="changeProfileUpdate(configureFields.profileUpdateGeography,'geography')" placeholder="Geography" >
														<md-option v-for="(value,index) in defaultProfileUpdateList" :key="index" :value="index">{{value}}</md-option>
													</md-select>
												</md-field>
											</div>
										</div>
										<!-- <div class="col-md-12 col-sm-6">
											<div class="col-md-1 mt-15">
												Skills
											</div>
											<div class="col-md-2">
												<md-field class="mt--6 mb-0">
													<md-select v-model="configureFields.profileUpdateSkills" name="profileUpdateSkills" @md-selected="changeProfileUpdate(configureFields.profileUpdateSkills,'skills')" placeholder="Skills" >
														<md-option v-for="(value,index) in defaultProfileUpdateList" :key="index" :value="index">{{value}}</md-option>
													</md-select>
												</md-field>
											</div>
										</div> -->
										<div class="col-md-12 col-sm-6">
											<div class="col-md-1 mt-15">
												LinkedIn URL
											</div>
											<div class="col-md-2">
												<md-field class="mt--6 mb-0">
													<md-select v-model="configureFields.profileUpdateLinkedInUrl" name="profileUpdateLinkedInUrl" @md-selected="changeProfileUpdate(configureFields.profileUpdateLinkedInUrl,'linkedInUrl')" placeholder="LinkedIn Url" >
														<md-option v-for="(value,index) in defaultProfileUpdateList" :key="index" :value="index">{{value}}</md-option>
													</md-select>
												</md-field>
											</div>
										</div>
										<!-- <div class="col-md-12 col-sm-6">
											<div class="col-md-1 mt-15">
												Biography
											</div>
											<div class="col-md-2">
												<md-field class="mt--6 mb-0">
													<md-select v-model="configureFields.profileUpdateBiography" name="profileUpdateBiography" @md-selected="changeProfileUpdate(configureFields.profileUpdateBiography,'biography')" placeholder="Biography" >
														<md-option v-for="(value,index) in defaultProfileUpdateList" :key="index" :value="index">{{value}}</md-option>
													</md-select>
												</md-field>
											</div>
										</div> -->
										<div class="col-md-12 col-sm-6">
											<div class="col-md-1 mt-15">
												Phone Number
											</div>
											<div class="col-md-2">
												<md-field class="mt--6 mb-0">
													<md-select v-model="configureFields.profileUpdatePhoneNumber" name="profileUpdatePhoneNumber" @md-selected="changeProfileUpdate(configureFields.profileUpdatePhoneNumber,'phoneNumber')" placeholder="Phone number" >
														<md-option v-for="(value,index) in defaultProfileUpdateList" :key="index" :value="index">{{value}}</md-option>
													</md-select>
												</md-field>
											</div>
										</div>
									</div>
									<hr class="request-hr m-left-5 ">
									<div class="row">
										<div class="col-md-12">
											<div class="col-md-4">
												<h4 class="mt-18">Request Options</h4>
											</div>
										</div>
									</div>
									<div class="row m-left-5 mt-10">
										<md-checkbox class="approval-response" v-model="content.athenaEnabled">Enable Athena for Long Wizard</md-checkbox>
									</div>
									<p class="error m-left-5" v-show="errors.has('form-content.athenaEnabled')">{{errors.first('form-content.athenaEnabled')}}</p>
									<div class="row m-left-5 mt-10">
										<md-checkbox class="approval-response" v-model="content.athenaEnabledQC">Enable Athena for Quick Connect</md-checkbox>
									</div>
									<p class="error m-left-5" v-show="errors.has('form-content.athenaEnabledQC')">{{errors.first('form-content.athenaEnabledQC')}}</p>
									<div class="row m-left-5 mt-10">
										<md-checkbox class="approval-response" v-model="content.questionCoachEnabledLF">Enable Question Coach for Long Wizard</md-checkbox>
									</div>
									<p class="error m-left-5" v-show="errors.has('form-content.questionCoachEnabledLF')">{{errors.first('form-content.questionCoachEnabledLF')}}</p>
									<div class="row m-left-5 mt-10">
										<md-checkbox class="approval-response" v-model="content.questionCoachEnabled">Enable Question Coach for Quick Connect</md-checkbox>
									</div>
									<p class="error m-left-5" v-show="errors.has('form-content.questionCoachEnabled')">{{errors.first('form-content.questionCoachEnabled')}}</p>
									<div class="row m-left-5 mt-10">
										<md-checkbox class="approval-response" v-model="content.enableMagicWandLF">Enable the Magic Wand feature for the Long Wizard</md-checkbox>
									</div>
									<p class="error m-left-5" v-show="errors.has('form-content.enableMagicWandLF')">{{errors.first('form-content.enableMagicWandLF')}}</p>
									<div class="row m-left-5 mt-10">
										<md-checkbox class="approval-response" v-model="content.magicWandEnabled">Enable the Magic Wand feature for Quick Connect</md-checkbox>
									</div>
									<p class="error m-left-5" v-show="errors.has('form-content.magicWandEnabled')">{{errors.first('form-content.magicWandEnabled')}}</p>

									<!-- <md-field class="create-community m-left-5">
										<label class="card-header">Request Form - Subject Line</label>
										<md-input v-model="requestForm.subjectLine" name="requestForm.subjectLine" placeholder='Request Form - Subject Line'></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.subjectLine')">{{errors.first('form-content.subjectLine')}}</p> -->
									<!-- <md-field class="create-community m-left-5">
										<label class="card-header">Request Form - Question</label>
										<md-input v-model="requestForm.question" name="requestForm.question" placeholder='Request Form - Question'></md-input>
									</md-field> -->
									<md-button class="md-raised md-round md-accent m-left-5" type="submit">{{ requestSaveContentText }}</md-button>
								</form>
							</div>
						</md-card-content>
					</md-card-expand-content>
		    	</md-card-expand>
			</md-card>
		</div>
		<CommunityContentSection :community_id="community_id" :content="content" :labelValidate="labelValidate"/>
		<div class="box mt-10">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5"><div @click="expandchannel('Campaigns')">Campaigns</div></md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="card-content">
							<div :class="{ opened: opened.includes('Campaigns') }" v-show="opened.includes('Campaigns')">
								<form @submit.prevent="saveCampaign('campaignsform-2')" data-vv-scope="campaignsform-2">
									<template v-for="index in 6">
										<div class="md-layout md-gutter md-field pt-0 mb-0 mlminus-15" :key="index">
											<div class="md-layout-item md-size-60 m-left-6">
												<md-field class="create-community">
													<label class="card-header">{{ getBannerLabel(index) }} Image URL </label>
													<md-input v-model.trim="campaign['banner'+index]['imageUrl']" :name="`banner${index}ImageUrl`" :placeholder="`${getBannerLabel(index)} Image URL`"  v-validate="{ required: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }" @input="campaign['banner'+index]['imageUrl'] = sanitizeUrl($event)"></md-input>
												</md-field>
												<p class="error" v-show="errors.has(`campaignsform-2.banner${index}ImageUrl`)">{{errors.first(`campaignsform-2.banner${index}ImageUrl`)}}</p>
											</div>
											<div class="md-layout-item md-size-40">
												<md-field class="create-community">
													<label class="card-header fs-12">{{ getBannerLabel(index) }} destination URL</label>
													<md-input v-model.trim="campaign['banner'+index]['destinationUrl']" :name="`banner${index}DestinationUrl`" :placeholder="`${getBannerLabel(index)} destination URL`"  v-validate="{ required: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }" @input="campaign['banner'+index]['destinationUrl'] = sanitizeUrl($event)"></md-input>
												</md-field>
												<p class="error" v-show="errors.has(`campaignsform-2.banner${index}DestinationUrl`)">{{errors.first(`campaignsform-2.banner${index}DestinationUrl`)}}</p>
											</div>
										</div>
									</template>
									<md-button type="submit" class="md-raised md-round md-accent mt-20">Save</md-button>
								</form>
							</div>
						</md-card-content>
	        		</md-card-expand-content>
		      	</md-card-expand>
			</md-card>
		</div>
		<div class="box mt-10">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="left">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5"><div @click="expandchannel('template')">Templates</div></md-button>
          				</md-card-expand-trigger>
						<font-awesome-icon class='small-icon picker-icon m-left-5' icon="plus-circle"  @click="addTemplate()"/>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="card-content">
							<div :class="{ opened: opened.includes('') }" v-show="opened.includes('template')">
								<form @submit.prevent="submitTemplates('form-template')" class="form-template" data-vv-scope="form-template">
									<div class="row" v-for="(temp, index) in selectTemp" :key="'template-'+index">
										<div class="col-md-5">
											<md-field class="m-left-5 md-has-value">
												<label for="original">Original</label>
												<md-select v-model="temp.original" @md-selected="selectOriginal(index, temp.original)" name="original" placeholder="Please select template">
													<md-option v-for="t in templates" :disabled="originalTemp.includes(t.ref_id)" :key="t.ref_id" :value="t.ref_id">{{t.name}}</md-option>
												</md-select>
											</md-field>
										</div>
										<div class="col-md-1 text-center">
											<img src="../assets/arrow.png" class="mt-25 angle-left-img-sm">
										</div>
										<div class="col-md-5">
											<md-field class="m-left-5 md-has-value">
												<label for="override">Override</label>
												<md-select v-model="temp.override" name="override"  placeholder="Please select template">
													<md-option v-for="t in templates" :key="t.ref_id" :value="t.ref_id">{{t.name}}</md-option>
												</md-select>
											</md-field>
										</div>
										<div class="col-md-1">
											<div class="mt-25">
												<a href="javascript:void(0)" class="text-primary" @click="deleteRow(index)">Delete</a>
											</div>
										</div>
									</div>
      								<md-button class="md-raised md-round md-accent m-left-5" type="submit">{{ saveContentText }}</md-button>
								</form>
							</div>
						</md-card-content>
					</md-card-expand-content>
		    	</md-card-expand>
			</md-card>
		</div>
		<div class="box mt-10">
		    <md-card>
		        <md-card-expand>
		            <md-card-actions md-alignment="space-between">
		                <md-card-expand-trigger>
		                    <md-button class="community-expand-button m-left-5"><div @click="expandchannel('email')">Email</div></md-button>
		                </md-card-expand-trigger>
		            </md-card-actions>
		            <md-card-expand-content>
		                <md-card-content class="card-content">
		                    <div :class="{ opened: opened.includes('email') }" v-show="opened.includes('email')">
		                    <form @submit.prevent="submitEmails('form-email')" data-vv-scope="form-email">
								<md-field class="m-left-5">
		                            <label for="original">Email Template</label>
		                            <md-select v-model="selectTemplate" v-validate="'required'" name="selectTemplate" placeholder="Please select template">
		                                <md-option v-for="t in templates" :key="t.ref_id" :value="t.ref_id">{{t.name}}</md-option>
		                            </md-select>
		                        </md-field>
		                        <p class="error m-left-5" v-show="errors.has('form-email.selectTemplate')">{{errors.first('form-email.selectTemplate')}}</p>
		                        <md-field>
		                            <label>Email Address</label>
		                            <md-textarea v-model="emailAddresses" v-validate="'required'" name="emailAddresses" placeholder="Enter email addresses" @input="emailAddresses = sanitizeInput($event)"></md-textarea>
		                            <span class="md-helper-text">Multiple email address must be comma(,) separated</span>
		                        </md-field>
		                        <p class="error m-left-5" v-show="errors.has('form-email.emailAddresses')">{{errors.first('form-email.emailAddresses')}}</p>
		                        <md-button type="submit" class="md-raised md-round md-accent mt-20">Send</md-button>
		                    </form>
		                    </div>
		                </md-card-content>
		            </md-card-expand-content>
		        </md-card-expand>
		    </md-card>
		</div>
		<md-card class="mt-10">
	    	<md-card-expand>
		        <md-card-actions md-alignment="left">
		        	<md-card-expand-trigger>
		        		<md-button class="community-expand-button m-left-5"><div @click="expandchannel('advisors')">Advisors</div></md-button>
	  				</md-card-expand-trigger>
	  				<div class="m-left-10">
						<member-picker v-on:chosen="addAdvisors" :community="$route.params.community_id" section="advisers">Choose advisor...</member-picker>
					</div>
	  			</md-card-actions>
	  			<md-card-expand-content>
	  				<md-card-content class="card-content">
  						<!--<p class="empty-admin-state" style="fontSize: 16px;color: grey;" v-show="opened.includes('2')"><small v-show="!advisorsList.length">Please select advisors</small></p>-->
						<p class="empty-admin-state m-left-5 m-remove" style="fontSize: 14px;color: grey;"><small>Note : Remove button will not display for partner communities advisors.</small></p>
						<search-bar
							v-model="searchAdvisors"
							placeholder="Search advisors..."
							name="searchAdvisor"
							@search="searchAdvisorsBtn"
							@clear="resetSearch('advisors')"
						/>
							<md-table :class="['advisor-table', { opened: opened.includes('advisors') }]" v-show="opened.includes('advisors')">
								<md-table-row v-if="advisorsList">
									<md-table-head class="card-header">Name
										&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentAdvisorSortDisplayName === 'desc'" @click="sortAdvisor('asc','displayName')" />
											<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentAdvisorSortDisplayName === 'asc'" @click="sortAdvisor('desc','displayName')" />
									</md-table-head>
									<md-table-head class="card-header">Email
											&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentAdvisorSortEmail === 'desc'" @click="sortAdvisor('asc','emails')" />
											<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentAdvisorSortEmail === 'asc'" @click="sortAdvisor('desc','emails')" />
									</md-table-head>
									<md-table-head class="card-header">Last Request Rec'd
											&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentAdvisorSortRequest === 'desc'" @click="sortAdvisor('asc','requestReceived.lastRequestReceived')" />
											<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentAdvisorSortRequest === 'asc'" @click="sortAdvisor('desc','requestReceived.lastRequestReceived')" />
									</md-table-head>
									<md-table-head class="card-header">Last Response
											&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentAdvisorSortResponse === 'desc'" @click="sortAdvisor('asc','response.lastResponse')" />
											<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentAdvisorSortResponse === 'asc'" @click="sortAdvisor('desc','response.lastResponse')" />
									</md-table-head>
									<md-table-head class="card-header">Last Feedback
										&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentAdvisorSortLastFeedback === 'desc'" @click="sortAdvisor('asc','lastFeedback')" />
											<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentAdvisorSortLastFeedback === 'asc'" @click="sortAdvisor('desc','lastFeedback')" />
									</md-table-head>
									<md-table-head class="card-header">Actions</md-table-head>
								</md-table-row>
								<template v-for="(advisor,index) in advisorsList">
									<!--<member :member="advisor" :key="'advisor_'+advisor._id">Advisor goes here...</member>-->
									<admin-list :member="advisor"  v-if="searchAdvisors !== '' && index < showSearchAdvisor" :key="'advisor_'+advisor._id+index" v-on:remove="removeAdvisor" dataType="advisor">Advisor goes here...</admin-list>
									<admin-list :member="advisor"  v-else-if="index < showAdvisors" :key="'advisor_'+advisor._id+index" v-on:remove="removeAdvisor" dataType="advisor">Advisor goes here...</admin-list>
								</template>
							</md-table>
							<div class="w-100 text-center mt-20" v-if="opened.includes('advisors')">
								<md-button class="md-mini btnplain capitalize card-header" @click="loadAdvisorsWithApi(searchAdvisors)" v-if="showAdvisorsLoadMore()">Load More</md-button>
							</div>
					</md-card-content>
			    </md-card-expand-content>
			</md-card-expand>
		</md-card>
		<md-card class="mt-10">
				<md-card-expand>
				<md-card-actions md-alignment="left">
					<md-card-expand-trigger>
						<md-button class="community-expand-button m-left-5"><div @click="expandchannel('members')">Members</div></md-button>
					</md-card-expand-trigger>
					<div class="m-left-10">
						<member-picker v-on:chosen="addMembers" section="members" :community="$route.params.community_id">Choose member...</member-picker>
					</div>
				</md-card-actions>
				<md-card-expand-content>
					<md-card-content class="card-content">
						<search-bar
							v-model="searchMembers"
							placeholder="Search members..."
							name="searchMember"
							@search="searchMemberBtn"
							@clear="resetSearch('members')"
						/>
						<md-table :class="['member-table', { opened: opened.includes('members') }]">
							<md-table-row v-if="membersList">
								<md-table-head class="card-header">Name
									&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMemberSortDisplayName === 'desc'" @click="sortMember('asc','displayName')" />
										<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMemberSortDisplayName === 'asc'" @click="sortMember('desc','displayName')" />
								</md-table-head>
								<md-table-head class="card-header">
										Email
										&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMemberSortEmail === 'desc'" @click="sortMember('asc','emails')" />
										<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMemberSortEmail === 'asc'" @click="sortMember('desc','emails')" />
								</md-table-head>
								<md-table-head class="card-header">Last Request Rec'd
										&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMemberSortRequest === 'desc'" @click="sortMember('asc','requestReceived.lastRequestReceived')" />
										<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMemberSortRequest === 'asc'" @click="sortMember('desc','requestReceived.lastRequestReceived')" />
								</md-table-head>
								<md-table-head class="card-header">Last Response
										&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMemberSortResponse === 'desc'" @click="sortMember('asc','response.lastResponse')" />
										<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMemberSortResponse === 'asc'" @click="sortMember('desc','response.lastResponse')" />
								</md-table-head>
								<md-table-head class="card-header">Last Feedback
									&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMemberSortLastFeedback === 'desc'" @click="sortMember('asc','lastFeedback')" />
										<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMemberSortLastFeedback === 'asc'" @click="sortMember('desc','lastFeedback')" />
								</md-table-head>
								<md-table-head class="card-header">Status</md-table-head>
							</md-table-row>
							<template v-for="(member , index) in membersList" v-if="opened.includes('members')">
								<member :member="member" v-if="searchMembers !== '' && index < showSearchMember" section="communityMembers" :key="'member_'+member._id+index">Member goes here...
								</member>
								<member :member="member" v-else-if="index < showMember" section="communityMembers" :key="'member_'+member._id+index">Member goes here...
								</member>
							</template>
						</md-table>
						<div class="w-100 text-center mt-20" v-if="opened.includes('members')">
							<md-button class="md-mini btnplain capitalize card-header" @click="loadMembersWithApi(searchMembers)" v-if="showMembersLoadMore()">Load More</md-button>
						</div>
				</md-card-content>
			</md-card-expand-content>
			</md-card-expand>
		</md-card>
		<md-card class="box mt-10">
			<md-card-expand>
				<md-card-actions md-alignment="left">
					<md-card-expand-trigger>
						<md-button class="community-expand-button m-left-5"><div @click="expandchannel('4')">Channels</div></md-button>
					</md-card-expand-trigger>
				</md-card-actions>
				<md-card-expand-content>
					<md-card-content class="card-content"  v-if="opened.includes('4')">
						<div class="m-left-5">
							<div class="md-layout md-gutter md-field pt-0 mb-0">
								<div class="md-layout-item md-size-60 m-left-6">
									<h4 class="m-left-5">Add Ask</h4>
									<div :class="['m-left-5 m-top-20', {picker: $lodash.has(createdByMember, '_id')}]">
										{{ createdByMember.displayName }}
										<member-picker v-on:chosen="addSeeker" iconName="Member" section="addAsk" :community="$route.params.community_id">Choose advisor...</member-picker>
									</div>
									<p class="error" v-if="this.isHasMember">Please select member</p>
								</div>
								<div class="md-layout-item md-size-40">
									<md-field class="create-community m-left-5">
										<label class="card-header">Community Ask Friendly Name</label>
										<md-input name="community_ask_friendly_name" v-model="friendlyNames.communityAsk"  placeholder="Community Ask Friendly Name" @input="friendlyNames.communityAsk = sanitizeInput($event)"></md-input>
									</md-field>
								</div>
							</div>
							<form @submit.prevent="sendCreate('form-1')" data-vv-scope="form-1" class="custom-textarea">
								<md-field class="create-ask m-left-5">
									<label class="card-header">Subject</label>
									<md-input v-model.trim="askSubject" name="subject" v-validate="'required'" placeholder="Request summary..." md-autogrow @input="askSubject = sanitizeInput($event)"></md-input>
								</md-field>
									<p class="error m-left-5" v-show="errors.has('form-1.subject')">{{errors.first('form-1.subject')}}</p>
								<md-field class="create-ask m-left-5">
									<label class="card-header">Description</label>
									<md-textarea v-model.trim="askText" name="description" v-validate="'required'" placeholder="Describe the request..." md-autogrow @input="askText = sanitizeInput($event)"></md-textarea>
								</md-field>
									<p class="error m-left-5" v-show="errors.has('form-1.description')">{{errors.first('form-1.description')}}</p>
								<md-button type="submit" class="md-raised md-round md-accent">
									Submit
								</md-button>
							</form>
						</div>
						<hr class="dark-border m-left-5 mt-40 mb-40">
						<form @submit.prevent="updateChannel('form-channel-2')" data-vv-scope="form-channel-2" class="form-channel-2">
							<div>
								<h4 class="m-remove m-left-5">
									<p class="empty-admin-state">Webform</p>
								</h4>
								<div class="md-layout md-gutter md-field pt-0 mb-0 mlminus-15">
									<div class="md-layout-item md-size-60 m-left-6">
										<md-field class="create-community m-left-5">
											<label class="card-header">Request Page - Single Page</label>
											<md-input class="not-allowed" v-model="content.requestPageURL" name="request page" readonly="" placeholder="Request Page URL" @input="content.requestPageURL = sanitizeUrl($event)" ></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-size-40">
										<md-field class="create-community m-left-5">
											<label class="card-header">Request Page - Single Page Friendly Name</label>
											<md-input  v-model="friendlyNames.requestForm" name="request_page_friendly_name" placeholder="Request Page Friendly Name" @input="friendlyNames.requestForm = sanitizeInput($event)"></md-input>
										</md-field>
									</div>
								</div>
								<!-- <div class="md-layout md-gutter md-field pt-0 mb-0 mlminus-15">
									<div class="md-layout-item md-size-60 m-left-6">
										<md-field class="create-community m-left-5">
											<label class="card-header">Request URL v1 - Long</label>
											<md-input class="not-allowed" v-model="content.requestV2URL" name="request page" readonly="" placeholder="Request URL v1 - Long"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-size-40">
										<md-field class="create-community m-left-5">
											<label class="card-header">Request Page v1 Friendly Name</label>
											<md-input  name="request_page_2_friendly_name" v-model="friendlyNames.requestForm2" placeholder="Request Page 2 Friendly Name"></md-input>
										</md-field>
									</div>
								</div> -->
								<p class="error m-left-5" v-if="errors.has('form-content.request page')">{{errors.first('form-content.request page')}}</p>
								<div class="md-layout md-gutter md-field pt-0 mb-0 mlminus-15">
									<div class="md-layout-item md-size-60 m-left-6">
										<md-field class="create-community m-left-5">
											<label class="card-header">Request Page - Long</label>
											<md-input class="not-allowed" v-model="content.requestV3URL" name="request page" readonly="" placeholder="Request Page - Long" @input="content.requestV3URL = sanitizeUrl($event)"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-size-40">
										<md-field class="create-community m-left-5">
											<label class="card-header">Request Page - Long Friendly Name</label>
											<md-input  v-model="friendlyNames.requestForm1" name="request_page_friendly_name" placeholder="Request Page Long Friendly Name" @input="friendlyNames.requestForm1 = sanitizeInput($event)"></md-input>
										</md-field>
									</div>
								</div>
								<p class="error m-left-5" v-show="errors.has('form-content.requestV2URL')">{{errors.first('form-content.requestV2URL')}}</p>
							</div>
							<hr class="dark-border m-left-5 mt-40 mb-40">

							<div class="md-layout md-gutter md-field pt-0 mb-0 mlminus-15">
								<div class="md-layout-item md-size-60 m-left-6">
									<md-card-actions md-alignment="left" class="ptop0">
										<h4>Emails</h4>
										<md-card-actions md-alignment="left">
											<font-awesome-icon class='small-icon picker-icon m-left-5' icon="plus-circle"  @click="showDialog = true"/>
										</md-card-actions>
									</md-card-actions>
									<md-dialog :md-active.sync="showDialog">
										<md-dialog-title>Authorize with</md-dialog-title>
										<md-dialog-actions>
											<img src="../assets/gmail.png" class="authorize-channel" @click="getGmailAuthURL">
											<img src="../assets/outlook.png" class="authorize-channel" @click="getOutlookAuthURL">
										</md-dialog-actions>
									</md-dialog>
									<!--<md-subheader class="community-subheader">Gmail Integration</md-subheader>
									<div class="md-layout-item" v-if="community.token">Credentials have been validated.<br />
										<md-button class="md-raised md-round md-accent" @click="getMail">Get Mail</md-button>
										<md-button class="md-raised md-round md-accent" @click="getGmailAuthURL">Re-Validate</md-button>
									</div>
									<div class="md-layout-item" v-if="!community.token">Valid credentials not yet saved.<br />
										<md-field v-if="isValidating">
											<label>Enter Validation Code:</label>
											<md-input v-model="validationCode"></md-input>
										</md-field>
										<md-button v-if="isValidating" class="md-raised md-round md-accent" @click="confirmCode">Confirm Code</md-button>
										<md-button v-if="!isValidating" class="md-raised md-round md-accent" @click="getGmailAuthURL">Validate</md-button>
									</div>-->
									<div class="m-left-8">
										<form @submit.prevent="confirmCode('form-3')" data-vv-scope="form-3" v-if="isValidating">
											<md-field class="md-focused md-field-margin">
												<label>Enter Validation Code:</label>
												<md-input v-model="validationCode" name="code" v-validate="'required'" @input="validationCode = sanitizeInput($event)"></md-input>
											</md-field>
											<p class="error" v-show="errors.has('form-3.code')">{{errors.first('form-3.code')}}</p>
											<md-button type="submit" class="md-raised md-round md-accent md-left-marign-remove">Confirm Code</md-button>
										</form>
									</div>
									<div class="channel-list m-left-5">
										<ul class="list-inline" v-for="(channel, index) in community.channels" :key="'channel-'+index">
											<li :key="'icon'+index">
												<template v-if="channel.authorizeMode === 'outlook'">
													<img v-if="channel.imageURL" :src="channel.imageURL" class="user-image">
													<img v-if="!channel.imageURL" class="user-image" src="../assets/person.png">
												</template>
												<md-avatar class="md-medium" v-else>
													<img v-if="channel.imageURL" :src="channel.imageURL" class="user-image">
													<img v-if="!channel.imageURL" class="user-image" src="../assets/person.png">
												</md-avatar>
											</li>
											<li :key="'email-'+index">{{ channel.memberEmail }}</li>
											<li :key="'channel-config-'+index"><span><font-awesome-icon class='small-icon' icon="pencil-alt" @click="expandContent(channel._id)" /></span></li>
											<li :key="'channel-config-'+index+'-delete'">
												<md-dialog-confirm :md-active.sync="activeChannel"
													:md-title="channel.memberEmail + ' Channel'"
													md-content="<strong>Are you sure you want to delete this channel? </strong>"
													@md-confirm="deleteChannel(channel._id)"
												/>
												<span>
													<a href="javascript:void(0)" @click="activeChannel = true">
														<i class="fa fa-trash" aria-hidden="true"></i>
													</a>
												</span>
											</li>
											<div class="channel-configuration" v-show="opened.includes(channel._id)" :key="'channel-data-'+index">
												<p><a class="display-link" @click="getMail(index)">Get Mail</a></p>
												<p>
													<md-checkbox v-model="community.channels[index].syncEnabled" @change="syncChannel(index)" v-if="!channel.lastSyncDate">Sync</md-checkbox>
													<md-checkbox v-model="community.channels[index].syncEnabled" :checked="community.channels[index].syncEnabled" @change="syncChannel(index)" v-if="channel.lastSyncDate">{{`Sync (last synced: ${$moment(channel.lastSyncDate).format('YYYY-MM-DD hh:mm')})`}}</md-checkbox>
												</p>
											</div>
										</ul>
									</div>
								</div>
								<div class="md-layout-item md-size-40">
									<md-field class="create-community m-left-5">
										<label class="card-header">Email Friendly Name</label>
										<md-input  name="email_friendly_name" v-model="friendlyNames.email" placeholder="Email Friendly Name" @input="friendlyNames.email = sanitizeInput($event)"></md-input>
									</md-field>
								</div>
							</div>
							<hr class="dark-border m-left-5 mt-40 mb-40">

							<div>
								<h4 class="m-remove m-left-5">
									<p class="empty-admin-state">Bot</p>
								</h4>
								<div class="md-layout md-gutter md-field pt-0 mb-0 mlminus-15">
									<div class="md-layout-item md-size-60 m-left-6">
										<md-field class="create-community m-left-5">
											<label class="card-header">Chatbot Page URL</label>
											<md-input class="not-allowed" :value="chatbotPageUrl" readonly="" placeholder="Chatbot Page URL" @input="chatbotPageUrl = sanitizeUrl($event)"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-size-40">
										<md-field class="create-community m-left-5">
											<label class="card-header">Chatbot Friendly Name</label>
											<md-input  name="chatbot_friendly_name" v-model="friendlyNames.chatbot" placeholder="Chatbot Friendly Name" @input="friendlyNames.chatbot = sanitizeInput($event)"></md-input>
										</md-field>
									</div>
								</div>
							</div>
							<md-button class="mt-20 md-raised md-round md-accent" type="submit">{{ saveChannelText }}</md-button>
						</form>
					</md-card-content>
				</md-card-expand-content>
			</md-card-expand>
		</md-card>
		<!-- interact -->
		<!-- mb-10: last card on the page; without it vue-scroll clips its bottom shadow -->
		<md-card class="mt-10 mb-10">
			<md-card-expand>
				<md-card-actions md-alignment="left">
					<md-card-expand-trigger>
						<md-button class="community-expand-button m-left-5"><div>Data Uploads</div></md-button>
						</md-card-expand-trigger>
				</md-card-actions>
				<md-card-expand-content>
					<md-card-content class="card-content">
						<div>
							<a href="https://storage.googleapis.com/protopia/app/web/sample-member-upload.csv" title="Download sample file" download>
								<md-button
									class="md-raised md-accent md-black-color capitalize"
									>Download Member Template</md-button
								>
							</a>
							<md-button
								class="md-raised md-accent md-black-color capitalize"
								@click="$refs.uploadMembersFile.click()"
								>Upload Members CSV File</md-button
							>
							<input
								type="file"
								accept=".csv"
								ref="uploadMembersFile"
								@change="uploadMembersNew"
								id="upload-members"
								style="display: none"
							/>
							<md-button
								class="md-raised md-accent md-black-color capitalize"
								:disabled="isDownloadBtnDisabled"
								v-if="isDownloadBtnDisabled"
								>Download Resources <i class="fa fa-spinner" aria-hidden="true"></i>
							</md-button>
							<md-button
								class="md-raised resource-btn md-black-color capitalize"
								@click="downloadResources()"
								:disabled="isDownloadBtnDisabled"
								v-else
								>Download Resources</md-button
							>
							<md-button
								class="md-raised resource-btn md-black-color capitalize"
								style="margin: 6px 8px;"
								@click="$refs.uploadResourcesFile.click()"
								>Upload Resources CSV File</md-button
							>
							<input
								type="file"
								accept=".csv"
								ref="uploadResourcesFile"
								@change="uploadResourcesNew"
								id="upload-resources"
								style="display: none"
							/>
							<md-button
								class="md-raised md-accent md-black-color capitalize"
								:disabled="isOpportunityTemplateDownloading"
								@click="downloadOpportunitiesTemplate()"
								>
								Download Opportunities Template
								<i v-if="isOpportunityTemplateDownloading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
							</md-button>
							<md-button
								class="md-raised md-accent md-black-color capitalize"
								:disabled="isOpportunityUploading"
								@click="$refs.uploadOpportunitiesFile.click()"
								>
								Upload Opportunities CSV File
								<i v-if="isOpportunityUploading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
							</md-button>
							<input
								type="file"
								accept=".csv"
								ref="uploadOpportunitiesFile"
								@change="uploadOpportunitiesNew"
								id="upload-opportunities"
								style="display: none"
							/>
						</div>
						<hr />
						<!-- Upload logs: collapsed by default, only one open at a time (SCRUM-712) -->
						<upload-log-section
							title="Member Uploads"
							:open="openUploadSection === 'members'"
							@toggle="toggleUploadSection('members')"
						>
							<recent-uploads :community_id="community._id"></recent-uploads>
						</upload-log-section>
						<upload-log-section
							title="Resource Uploads"
							:open="openUploadSection === 'resources'"
							@toggle="toggleUploadSection('resources')"
						>
							<recent-resource-uploads :community_id="community._id"></recent-resource-uploads>
						</upload-log-section>
						<upload-log-section
							title="Opportunity Uploads"
							:open="openUploadSection === 'opportunities'"
							@toggle="toggleUploadSection('opportunities')"
						>
							<div v-if="opportunityUploads.length === 0" style="color: #888; padding: 8px 4px">
								No opportunity files have been uploaded yet.
							</div>
							<div
								v-for="upload in opportunityUploads"
								:key="upload._id"
								style="margin: 5px; padding: 5px;"
								class="email"
							>
								<b style="color:purple;font-size:16px">File: {{ upload.fileName || 'Unknown file' }}</b><br />
								<b>On:</b> {{ new Date(upload.when).toLocaleDateString() }} {{ new Date(upload.when).toLocaleTimeString() }},
								<b>Created:</b> {{ upload.created }},
								<b>Duplicates:</b> {{ upload.duplicates }},
								<b>Failed:</b> {{ upload.failedCount }}<br />
								<button
									v-if="upload.failed.length"
									@click="toggleOpportunityFailed(upload._id)"
								>
									{{ isOpportunityFailedVisible(upload._id) ? 'Close Failed' : 'Show Failed' }}
								</button>
								<div v-if="isOpportunityFailedVisible(upload._id)" style="margin-top: 8px;">
									<div
										v-for="(err, ei) in upload.failed"
										:key="`opp-upload-${upload._id}-err-${ei}`"
										style="padding: 2px 0;"
									>
										-- Row <b>{{ err.row }}</b>: <span style="color:#c00">{{ err.error }}</span>
									</div>
								</div>
							</div>
						</upload-log-section>
					</md-card-content>
				</md-card-expand-content>
			</md-card-expand>
		</md-card>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import Member from "./Member";
import MemberPicker from "./MemberPicker";
import AdminList from './AdminList';
import SemesterDateBlock from './SemesterDateBlock';
import DatePicker from 'vue2-datepicker';
import RecentUploads from "@/components/RecentUploads";
import RecentResourceUploads from "@/components/RecentResourceUploads";
import UploadLogSection from "@/components/partials/community/UploadLogSection";
import 'vue2-datepicker/index.css';
import CommunityContentSection from "./partials/community/__CommunityContentSection";
import PartnerCommunityList from './PartnerCommunityList.vue';
import Circles from './Circles.vue';
import CommunityRecruitingConfig from './CommunityRecruitingConfig.vue';
import Vue from 'vue';
import { exportCSV } from '@/assets/js/common';
import SearchBar from './SearchBar.vue';

import { sanitizeInput, sanitizeUrl, ensureHttpsScheme, sanitizeHtmlTemplate, sanitizeResourceDescription, sanitizeCss, sanitizeScript, sanitizeHtmlAttributes } from '@/utils/sanitizer';
import EventBus from '../assets/js/EventBus';
import axios from 'axios';
import { CORE_API_URL } from '../services/opportunityAdapter';


export default {
  components: {
		RecentUploads,
		RecentResourceUploads,
		UploadLogSection,
		Member,
		MemberPicker,
		AdminList,
		DatePicker,
		CommunityContentSection,
		PartnerCommunityList,
		Circles,
		SearchBar,
		SemesterDateBlock,
		CommunityRecruitingConfig,
  },
  props: ["community_id"],
  data() {
    return {
		api: new API(),
		askSubject: "",
		askText: "",
		createdByMember: {},
		saveText: "save",
		saveStyleText: "save",
		copyText: "Copy Community",
		community: {
			syncEnabled: false,
			sendgrid: {
			},
			sender: {
				name: "",
				address: ""
			},
			rules: {
				workflow: {
					requestEscalation: 10,
					menteeReminder: false,
					type: 'Weekly',
					moduleResources: false
				}
			}
		},
		customSettings: {

		},
		settings: {},
		advisors: [],
		administrators: [],
		members: [],
		isValidating: false,
		validationCode: "",
		changeSyncText: "Sync",
		active: false,
		opened: [],
		fullPage: true,
		communities: [],
		content: {},
		requestForm: {
			subjectLine: 'Short summary ...',
			question: "I have a question about ..."
		},
		saveContentText: "save",
		requestSaveContentText: "save",
		isHasMember: false,
		showDialog: false,
		searchAdvisors: "",
		searchMembers: "",
		membersList: [],
		advisorsList: [],
		successCount: 0,
		rejectCount: 0,
		updateCount: 0,
		currentMemberSortEmail: 'desc',
		currentMemberSortRequest: 'desc',
		currentMemberSortResponse: 'desc',
		currentMemberSortLastFeedback: 'desc',
		currentMemberSortDisplayName: 'desc',
		currentAdvisorSortEmail: 'desc',
		currentAdvisorSortRequest: 'desc',
		currentAdvisorSortResponse: 'desc',
		currentAdvisorSortLastFeedback: 'desc',
		currentAdvisorSortDisplayName: 'desc',
		configureFields: {
			college: {
				include: false,
				require: false,
				chatbotLabelName: 'What program do you (did you) attend?'
			},
			college2: {
				include: false,
				require: false,
				chatbotLabelName: 'What program do you (did you) attend?'
			},
      major: {
				include: false,
				require: false,
				chatbotLabelName: 'What is your major?'
			},
			classYear: {
				include: false,
				require: false,
				chatbotLabelName: 'What year?'
			},
			classYear2: {
				include: false,
				require: false,
				chatbotLabelName: 'What year?'
			},
			title: {
				include: false,
				require: false,
				chatbotLabelName: "What's your job title?"
			},
			organization: {
				include: false,
				require: false,
				chatbotLabelName: 'What organization do you work for?'
			},
			studentId: {
				include: false,
				require: false,
				chatbotLabelName: 'What is your student ID?'
			},
			dueDate: {
				include: false,
				require: false,
				chatbotLabelName: 'Does your request have an expiration date?'
			},
			linkedInProfile: {
				include: false,
				require: false,
				chatbotLabelName: 'Do you have a LinkedIn profile? If so, what is the URL?'
			},
			phoneNumber: {
				include: false,
				require: false,
				chatbotLabelName: 'Can we text you occasionally alerts and reminders to help you engage?'
			},
			referrer: {
				include: false,
				require: false
			},
			referrer2: {
				include: false,
				require: false
			},
			disclaimer: {
				include: false,
				require: false,
				chatbotLabelName: 'Can you commit to courteous and quick follow up to ensure experts will continue to help others?'
			},
			interest: {
				include: false,
				description: 'One more thing, please.\n\nOften, shared experiences and interests help us make even better matches. While not required, we would love for you to select one or more of the below topics you care about so that we can find the best experts to help you with your request.'
			},
			memberRole: {
				include: false,
				require: false,
				chatbotLabelName: 'In what capacity are you asking?'
			},
			adviceArea: {
				include: false,
				require: false,
				chatbotLabelName: 'What type of request do you have?'
			},
			firstName: {
				include: true,
				require: true
			},
			lastName: {
				include: true,
				require: true
			},
			emailAddress: {
				include: true,
				require: true
			},
			subject: {
				include: true,
				require: true
			},
			question: {
				include: true,
				require: true
			}
		},
		saveSiteStatusText: 'Save',
		showMember: 100,
		showAdvisors: 100,
		showTotalRecord: 100,
		newAdmin: [],
		skipAdvisors: 0,
		skipMembers: 0,
		activeChannel: false,
		maxParameters: 100,
		maxWelcome: 5000,
		skipSearchMembers: 0,
		showSearchMember: 100,
		skipSearchAdvisors: 0,
		showSearchAdvisor: 100,
		matchingThreshold: 25,
		ratio: 50,
		minimum_advisors_ratio: 0,
		minimum_responses_ratio: 0,
		dialogeLoading: false,
		mapAdviser: [],
		matchingAlgorithm: {},
		suApprovalRequest: false,
		suApprovalResponse: false,
		mgmtRequest: false,
		mgmtResponse: false,
		suAlert: {},
		superUserEmailValidate: false,
		recruitAdvisor: '',
		askAgainFeedbackFrequency: {},
		isSenderEmailAddress: false,
		memberEngagementEmail: false,
		selectTemp: [],
		templates: [],
		originalTemp: [],
		days: 0,
		minimum_advisors: 0,
		maximum_advisors: 0,
		advisorCount: 100,
		memberRoleValue: false,
		chatbotMemberRoleValue: false,
		adviceAreaValue: false,
		chatbotAdviceAreaValue: false,
		college2Value: false,
		referrer2Value: false,
		chatbotCollege2Value: false,
		classYear2Value: false,
		chatbotClassYear2Value: false,
		selectTemplate: '',
		emailAddresses: '',
		semesterSummary: {
			member: true,
			date1: '',
			date2: '',
			date3: '',
			date4: '',
			range1: null,
			range2: null,
			range3: null,
			range4: null
		},
		campaign: {
			banner1: {
				imageUrl: '',
				destinationUrl: ''
			},
			banner2: {
				imageUrl: '',
				destinationUrl: ''
			},
			banner3: {
				imageUrl: '',
				destinationUrl: ''
			},
			banner4: {
				imageUrl: '',
				destinationUrl: ''
			},
			banner5: {
				imageUrl: '',
				destinationUrl: ''
			},
			banner6: {
				imageUrl: '',
				destinationUrl: ''
			}
		},
		linkedinCredentials: {
			clientId: process.env.LINKEDIN_CLIENT_ID,
			clientSecret: process.env.LINKEDIN_CLIENT_SECRET
		},
		feedbackRequestDefaultText: "We get great feedback on {{ community.parameter1 }} and we're trying to show just how helpful of a tool it can be. Would you be willing to share a quick testimonial on your experience that we can share with others? Just 2-3 sentences would be incredibly helpful for us to get the word out. Thank you.",
		donorAlertDefaultText: "A constituent assigned to you has volunteered by mentoring someone via <a href='{{ community.url }}'>{{ community.parameter2 }}</a>",
		chatbotPageUrl: `${process.env.APP_BASEURL}chatbot/${this.community_id}`,
		friendlyNames: {},
		savePartnerCommunityText: 'Save',
		partnerCommsButton: false,
		partnerCommunities: [],
		saveRulesText: 'Save',
		saveChannelText: 'Save',
		defaultProfileUpdateList: {0: 'Do not display', 1: 1, 2: 2, 3: 3, 4: 4, 5: 5},
		isDisabled: process.env.NODE_ENV === 'production',
		isDownloadBtnDisabled: false,
		// Bulk opportunities CSV import
		opportunityUploads: [],
		opportunityFailedVisible: {},
		isOpportunityTemplateDownloading: false,
		isOpportunityUploading: false,
		// Data Uploads log section currently open (only one at a time): null | 'members' | 'resources' | 'opportunities'
		openUploadSection: null,
		countries: [
      { code: 'US', name: 'United States' },
      { code: 'GB', name: 'United Kingdom' },
      { code: 'IN', name: 'India' }
    ],
    statesByCountry: {
      'US': [
        'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
        'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
        'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
        'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
        'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
        'West Virginia', 'Wisconsin', 'Wyoming'
      ],
      'GB': [
        'England', 'Scotland', 'Wales', 'Northern Ireland'
      ],
      'IN': [
        'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana',
        'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya',
        'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
        'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
      ]
    },
    states: [],
    	selectedCountry: '',
    	selectedState: '',
    	city: '',
		latitude: '',
		longitude: ''
    };
  },
  watch: {
    '$route': {
		immediate: true,
		handler(newRoute, oldRoute) {
			// Only reload if community_id changed or this is first load
			if (!oldRoute || newRoute.params.community_id !== oldRoute.params.community_id) {
				// Reset location data only when community changes
				this.resetLocationData();
				this.loadData();
				this.loadOpportunityUploads();
			}
		}
	}
  },
  created: async function() {
	const dict = {
		custom: {
			matching_threshold: {
				required: "Please enter Minimum threshold between 1 to 100.",
				min_value: "Minimum threshold value must be 1 or more.",
				max_value: 'Maximum threshold value must be 100 or less.'
			},
			minimum_advisors_ratio: {
				required: "Please select Advisor Minimum ratio."
				//min_value: "Advisor Minimum ratio must be 5 or more.",
			},
			minimum_responses_ratio: {
				required: "Please select Response Minimum ratio."
				//min_value: "Response Minimum ratio must be 2 or more.",
			},
			primaryBtnBgColor: {
				required: "Please enter hex code",
				regex: "Please enter a valid hex code"
			},
			primaryTxtColor: {
				required: "Please enter hex code",
				regex: "Please enter a valid hex code"
			},
			secondaryBtnBgColor: {
				required: "Please enter hex code",
				regex: "Please enter a valid hex code"
			},
			secondaryTxtColor: {
				required: "Please enter hex code",
				regex: "Please enter a valid hex code"
			},
			thirdBtnBgColor: {
				required: "Please enter hex code",
				regex: "Please enter a valid hex code"
			},
			thirdTxtColor: {
				required: "Please enter hex code",
				regex: "Please enter a valid hex code"
			},
			formThankyou: {
				required: "Please enter request form thank you message"
			},
			snoozeMessage: {
				required: "Please enter message for snooze"
			},
			communitySite: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			twilio_phone_number: {
				required: "Please Enter Phone Number",
				regex: "Please enter valid Number with Country code"
			},
			responseEngagementTip: {
				regex: "Please enter a valid URL"
			},
			advisorThankYou: {
				regex: "Please enter a valid URL"
			},
			memberThankYou: {
				regex: "Please enter a valid URL"
			},
			days: {
				required: "Please select days ratio."
			},
			minimum_advisors: {
				required: "Please select Minimum adviser.",
				max_value: 'Minimum advisers less than maximum advisers'
			},
			maximum_advisors: {
				required: "Please select Advisor Minimum ratio."
			},
			requestReceivedReduction: {
				decimal: "Please enter Numbers only",
				max_value: 'Maximum value must be 100 or less.',
				min_value: 'Minimum value must be 0 or more.'
			},
			responseSharedDiscount: {
				decimal: "Please enter Numbers only",
				max_value: 'Maximum value must be 100 or less.',
				min_value: 'Minimum value must be 0 or more.'
			},
			referralMessage: {
				required: "Please enter referral message."
			},
			selectTemplate: {
				required: "Please select template"
			},
			emailAddresses: {
				required: "Please enter email address"
			},
			banner1ImageUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner2ImageUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner3ImageUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner4ImageUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner5ImageUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner6ImageUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner1DestinationUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner2DestinationUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner3DestinationUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner4DestinationUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner5DestinationUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			banner6DestinationUrl: {
				required: "Please enter URL",
				regex: "Please enter a valid URL"
			},
			linkedInClientId: {
				required: "Please enter LinkedIn Client ID"
			},
			linkedInClientSecret: {
				required: "Please enter LinkedIn Client Secret"
			}
		}
	};
	this.$validator.localize('en', dict);
	this.loadData();
  },
  beforeDestroy() {
    // Reset favicon to default when leaving the community page
    console.log('Community: Component destroying, resetting favicon');
    EventBus.$emit('change-favicon', 'https://storage.googleapis.com/protopia/images/protopia_favicon.png');
  },
  methods: {
	loadData: async function() {
		try {
			this.isSenderEmailAddress = false;
			this.advisorsList = this.membersList = [];
			this.api.get(`communities/${this.community_id}`).then(async community => {
				if (community.data) {
					this.community = community.data;

					if (this.community.customSettings && this.community.customSettings.faviconURL !== 'none') {
						console.log('Community: Emitting favicon change', this.community.customSettings.faviconURL);
						EventBus.$emit('change-favicon', this.community.customSettings.faviconURL);
					} else {
						EventBus.$emit('change-favicon', 'https://storage.googleapis.com/protopia/images/protopia_favicon.png');
					}
					this.suApprovalRequest = community.data.suApproval.request;
					this.suApprovalResponse = community.data.suApproval.response;
				this.mgmtRequest = community.data.mgmtApproval.request;
				this.mgmtResponse = community.data.mgmtApproval.response;
					this.suAlert = community.data.suAlert;
					if (community.data.mgmtApproval.request || community.data.suApproval.response || community.data.suApproval.request || community.data.suApproval.response || community.data.suAlert.request || community.data.suAlert.response || community.data.suAlert.noResponse || community.data.suAlert.feedback) {
						this.superUserEmailValidate = true;
					}
					// if (this.community.name === 'Webs (Dev)' || this.community.name === 'University' || this.community.name === 'University Demo' || this.community.name === 'Developers') {
					// 	this.isSenderEmailAddress = true;
					// }

					if (this.community.linkedinCredentials && this.community.linkedinCredentials.clientId) {
						this.linkedinCredentials.clientId = this.community.linkedinCredentials.clientId;
					}

					if (this.community.linkedinCredentials && this.community.linkedinCredentials.clientSecret) {
						this.linkedinCredentials.clientSecret = this.community.linkedinCredentials.clientSecret;
					}

					this.matchingAlgorithm = community.data.matching;
					this.mapAdviser = community.data.mapAdviser;
					this.community.sender = community.data.sender || {};
				this.community.rules = community.data.rules ? community.data.rules : {};
				if (this.community.rules && this.community.rules.semesterSummary) {
					this.semesterSummary = {
						...this.semesterSummary,
						...this.community.rules.semesterSummary
					};
				}
				if (this.community.rules) {
					this.community.rules.workflow.requestEscalation = this.community.rules.workflow.requestEscalation
					this.community.rules.workflow.menteeReminder = this.community.rules.workflow.menteeReminder
					this.community.rules.workflow.type = this.community.rules.workflow.type
					this.community.rules.workflow.moduleResources = this.community.rules.workflow.moduleResources

        } else {
						this.community.rules.workflow.requestEscalation = 10
						this.community.rules.workflow.menteeReminder = false
						this.community.rules.workflow.type = 'Weekly'
						this.community.rules.workflow.moduleResources = false

					}
					if (this.community.campaign) {
						this.campaign = this.community.campaign;
						for (let banner = 1; banner <= 6; banner++) {
							if (this.community.campaign['banner' + banner]) {
								this.campaign['banner' + banner] = this.community.campaign['banner' + banner];
							} else {
								this.campaign['banner' + banner] = {
									imageUrl: '',
									destinationUrl: ''
								}
							}
						}
					}
					this.friendlyNames = this.community.friendlyNames;
					if (this.community.location) {
						// Find the matching country object
						const foundCountry = this.countries.find(country => country.name === this.community.location.country);
						this.selectedCountry = foundCountry || '';
						if (foundCountry) {
						// Load states for the selected country
							this.states = this.statesByCountry[foundCountry.code] || [];
						}
						this.selectedState = this.community.location.state;
						this.city = this.community.location.city;
						this.latitude = this.community.location.latitude;
						this.longitude = this.community.location.longitude;
					}

					this.askAgainFeedbackFrequency = community.data.rules.askAgainFeedbackFrequency;
					this.content = community.data.content || {};
					if (this.content.requestPageURL && this.content.requestPageURL.includes(process.env.APP_BASEURL) === false) {
						this.content.requestPageURL = `${process.env.APP_BASEURL}community-request/${this.community._id}`
					}
					if (this.content.requestV3URL && this.content.requestV3URL.includes(process.env.APP_BASEURL) === false) {
						this.content.requestV3URL = `${process.env.APP_BASEURL}community-request-v3/${this.community._id}`
					}
					if (this.content.unsubscribePageURL && this.content.unsubscribePageURL.includes(process.env.APP_BASEURL) === false) {
						this.content.unsubscribePageURL = `${process.env.APP_BASEURL}unsubscribe/${this.community._id}`;
					}
					// if (!this.content.requestV3URL) {
					// 	this.content.requestV3URL = `${process.env.APP_BASEURL}community-request-v3/${this.community._id}`
					// }
					if (community.data.content.requestForm) {
						this.requestForm.subjectLine = community.data.content.requestForm.subjectLine || 'Short summary ...';
						this.requestForm.question = community.data.content.requestForm.question || "I have a question about ...";
					}
					this.settings = community.data.settings || {};
					this.matchingThreshold = community.data.rules ? community.data.rules.matchingThreshold : 25;
					this.minimum_advisors_ratio = community.data.rules ? community.data.rules.minimum_advisors_ratio : 5;
					this.days = community.data.rules ? community.data.rules.days : 2;
					this.minimum_advisors = community.data.rules ? community.data.rules.minimum_advisors : 5;
					this.maximum_advisors = community.data.rules ? community.data.rules.maximum_advisors : 15;
					this.minimum_responses_ratio = community.data.rules ? community.data.rules.minimum_responses_ratio : 2;
					// set initial value for checkboxes
					this.configureFields = community.data.content.configureFields;
					this.selectTemp = this.community.overrideTemplate;
					this.originalTemp = [];
					for (var i = 0; i < this.selectTemp.length; i++) {
						for (var j = 0; j < this.templates.length; j++) {
							if (this.templates[j].ref_id === this.selectTemp[i].original) {
								this.originalTemp.push(this.templates[j].ref_id)
							}
						}
					}
					if (community.data.lastSync) {
						this.changeSyncText = `Sync (last synced: ${this.$moment(community.data.lastSync).format('YYYY-MM-DD')})`
					} else {
						this.changeSyncText = 'Sync';
					}
					this.members = [];
					if (community.data && community.data.advisors) {
						this.advisorsList = this.advisors = community.data.advisors;
					}
					if (community.data && community.data.members) {
						this.membersList = this.members = community.data.members;
					}
					if (community.data && community.data.administrators) {
						this.administrators = community.data.administrators;
						this.administrators.map(singleAdmin => {
							if (singleAdmin.memberId) {
								this.newAdmin.push(singleAdmin.memberId);
							}
						})
					}
					this.api
					.get('communities/all')
					.then(communities => {
						this.communities = communities.data;
					});
					this.api.get(`templates`).then(templates => {
						this.templates = this.$lodash.orderBy(templates.data, ['name'], ['asc']);
					});
					var pCommunity = community.data.partnerCommunities;
					this.community.partnerCommunities = this.partnerCommunities = [...new Set(pCommunity)];
					this.initialValidation();
				}
			});
			await this.$nextTick();
			if (this.$validator) {
				this.$validator.errors.clear();
				this.$validator.reset();
			}
			this.initialValidation();
		} catch (error) {
			console.error("error in loaddata: ", error);
		}
	},
	resetLocationData() {
		this.selectedCountry = '';
		this.selectedState = '';
		this.city = '';
		this.states = [];
		this.latitude = '';
		this.longitude = '';
	},
	 resetLocationData() {
    this.selectedCountry = '';
    this.selectedState = '';
    this.city = '';
    this.states = [];
    this.latitude = '';
    this.longitude = '';
  },
	  validateSemesterSummary: function () {
		  if (!this.semesterSummary.member) {
			  return true;
		  }
		  const hasAnyDate = this.semesterSummary.date1 || this.semesterSummary.date2 || this.semesterSummary.date3 || this.semesterSummary.date4;
		  if (!hasAnyDate) {
			  this.$toast.error('Please provide at least one semester summary date when member summary is enabled');
			  return false;
		  }
		  for (let i = 1; i <= 4; i++) {
			  const dateKey = `date${i}`;
			  const rangeKey = `range${i}`;
			  const date = this.semesterSummary[dateKey];
			  const range = this.semesterSummary[rangeKey];

			  if (date && !range) {
				  this.$toast.error(`Please provide a range for Semester Summary Date ${i}`);
				  return false;
			  }
		  }
		  return true;
	  },
	getMemberAdviser: function(type) {
		this.api.get(`communities/${this.community_id}/getMemberAdviser?type=${type}&partnerCommunities=${this.community.partnerCommunities}`).then(memberAdverData => {
			if (memberAdverData.data) {
				this.members = [];
				if (memberAdverData.data && memberAdverData.data.advisors.length) {
					this.advisorsList = this.advisors = memberAdverData.data.advisors;
				}
				if (memberAdverData.data && memberAdverData.data.members.length) {
					this.membersList = this.members = memberAdverData.data.members;
				}
			}
		});
	},
    saveCommunitySetting: async function(scope) {
		this.$validator.validateAll(scope).then(async community => {
			if (community) {
				if (this.linkedinCredentials.clientId.trim() == '' || this.linkedinCredentials.clientSecret == '') {
					this.linkedinCredentials.clientId = process.env.LINKEDIN_CLIENT_ID;
					this.linkedinCredentials.clientSecret = process.env.LINKEDIN_CLIENT_SECRET
				}
				this.community.linkedinCredentials = {
					clientId: this.linkedinCredentials.clientId,
					clientSecret: this.linkedinCredentials.clientSecret
				}

				if (this.city && this.selectedState && this.selectedCountry) {
					const locationQuery = `${this.city}, ${this.selectedState}, ${this.selectedCountry.name}`;
      				const response = await fetch(
						`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(locationQuery)}&limit=1`,
						{
							headers: {
								'Accept': 'application/json',
								'User-Agent': 'Location Verification Service'
							}
						}
					);

					const data = await response.json();
					console.log("Lat Long Data:", data);

					if (data && data.length > 0) {
						this.latitude = data[0].lat;
						this.longitude = data[0].lon;
					} else {
						this.$toast.error('Could not find coordinates for the specified location. Please verify the city name.');
						return;
					}
				}

				const setting = {
					name: this.community.name,
					code: this.community.code,
					sftpUser: this.community.sftpUser,
					sftpPwd: this.community.sftpPwd,
					sftpAutomated: this.community.sftpAutomated,
					salesforceOrgId: this.community.salesforceOrgId,
					timezone: this.community.timezone,
					location: {
						country: this.selectedCountry ? this.selectedCountry.name : '',
						state: this.selectedState,
						city: this.city,
						latitude: this.latitude,
						longitude: this.longitude
					},
					communityPortal: this.community.communityPortal,
					linkedinCredentials: this.linkedinCredentials,
					profileLink: this.community.profileLink,
					communitySite: this.community.communitySite,
					programPageUrl: this.community.programPageUrl,
					trackingScript: this.community.trackingScript,
					syncEnabled: this.community.syncEnabled,
					isAllMembersAreAdvisers: this.community.isAllMembersAreAdvisers,
					sendgrid: { token: this.community.sendgrid.token },
					emailFormat: this.community.emailFormat,
					sender: { name: this.community.sender.name, address: this.community.sender.address },
					is_sender_email_address: this.community.is_sender_email_address,
					is_sms_enable: this.community.is_sms_enable,
					twilio_phone_number: this.community.twilio_phone_number,
					member_only_access: this.community.member_only_access,
					mapAdviser: this.mapAdviser,
					propertyID: this.community.propertyID
				}
		      	await this.api.put(`communities/${this.community_id}/update-community-settings`, setting).then(community => {
		          	this.saveText = "saved";
				  	// this.community = community.data;
				  	// this.community.sender = community.data.sender || {};
					this.community = {...this.community, ...community.data};

		          	// Emit event with updated name so Layout can sync immediately
		          	if (community.data && community.data.name) {
		          		this.$root.$emit('community-name-changed', {
		          			communityId: this.community_id,
		          			newName: community.data.name
		          		});
		          	}

		          	this.$emit("reload");
		        });
			}
		});
    },
	createCommunityCopy: async function() {
		if (process.env.NODE_ENV == "production") {
			this.$emit("reload")
		} else {
			await this.api.post(`communities/${this.community_id}/copy`).then(community => {
				this.copyText = "Copied";
				this.isDisabled = true;
				this.$emit("reload");
			});
		}
	},
    saveStyle: async function(scope) {
		this.$validator.validateAll(scope).then(async valid => {
			if (valid) {
				this.isValidating = false;
				var customSettings = this.community.customSettings;

				await this.api
		          .put(`communities/${this.community_id}/update-community-style`, {customSettings: customSettings})
		          .then(community => {
		            this.saveStyleText = "saved";
					this.community = {...this.community, ...community.data};
		            this.$emit("reload");
		          });
			}
	  	});
	},
    addSeeker: function(members) {
      	this.api.get(`members/${members[0]}`).then(member => {
			this.createdByMember = member.data;
			this.isHasMember = false;
    	});
    },
    addAdvisors: async function(members) {
		await this.api
        	.post(`communities/${this.community_id}/add-members`, {
          	advisorList: members
        })
        .then(community => {
			this.getMemberAdviser('advisors');
        });
    },
    addMembers: async function(members) {
      	await this.api
        .post(`communities/${this.community_id}/add-members`, {
          	memberList: members
        })
        .then(community => {
			this.getMemberAdviser('members');
        });
    },
    addAdministrators: async function(members) {
      	await this.api
        .post(`communities/${this.community_id}/add-members`, {
          	administratorList: members
        })
        .then(community => {
		  	setTimeout(() => {
				this.loadData();
			}, 500);
        });
    },
    confirmCode: async function(scope) {
      	this.$validator.validateAll(scope).then(async valid => {
			if (valid) {
				this.isValidating = false;
				await this.api
				.post(`communities/${this.community_id}/confirm_auth`, {
				validationCode: this.validationCode,
				channels: [this.community.channels]
				})
				.then(community => {
					this.community = community.data;
				});
			}
	  	});
    },
    getGmailAuthURL: async function() {
      	this.community.token = null;
      	this.isValidating = true;
      	await this.api.get(`communities/request_auth`).then(resp => {
			this.showDialog = false;
        	window.open(resp.data, "_blank");
        });
	},
	getOutlookAuthURL: async function() {
		this.community.token = null;
		await this.api.get(`communities/outlook/request_auth?community_id=${encodeURI(this.$route.params.community_id)}`).then(resp => {
			this.showDialog = false;
    		window.open(resp.data, "_blank");
    	});
    },
    getMail: async function(index) {
		await this.api.get(`communities/${this.community_id}/mail/${index}`).then(resp => {
			if (typeof resp.data === 'string') {
				this.$toast.success(resp.data);
			}
		});
    },
    sendCreate: async function(scope) {
    	this.$validator.validateAll(scope).then(async result => {
    		if (result) {
				if ('_id' in this.createdByMember) {
					this.isHasMember = false;
			    	var newAsk = {
				        subject: this.askSubject,
				        text: this.askText,
				        community: this.community._id,
				        createdByMemberID: this.createdByMember._id,
				        source: {
				          origin: "web",
				          sourceID: `timestamp:${Date.now()}`,
				          userID: "Web user"
				        },
			        	recipients: this.newAdmin,
						channelType: this.friendlyNames.communityAsk || "Community"
			    	};
					if (typeof newAsk.subject == 'undefined' || newAsk.subject === '') {
						this.$toast.error(`Please enter valid subject for the request.`);
						return false;
					}
			    	await this.api
					.post(`communities/${this.community._id}/ask`, newAsk)
					.then(ask => {
						if (ask.data.isSpam) {
							this.$toast.error('Member email address has been blocked.');
						} else if (ask.data.invalidMember || ask.data.inactiveMember) {
							let re = new RegExp(`\\{\\{\\s?community.email\\s?\\}\\}`, 'gi');
        					let invalidMsg = this.community.content.invalidMemberMessage.replace(re, (this.community.sender && this.community.sender.address) ? this.community.sender.address : process.env.DEFAULT_EMAIL);
							this.$toast.error(invalidMsg, {duration: 10000});
						} else {
							setTimeout(() => {
								this.$router.push(`/asks/${ask.data._id}/request`);
							}, 500);
						}
					});
				} else {
					this.isHasMember = true;
				}
    		}
    	});
    },
    removeAdministrator: async function(id) {
    	let admin = this.newAdmin.filter((admin, index) => {
    			if (admin._id === id) {
    			return admin;
    		}
		});
    	await this.api
        .post(`communities/${this.community_id}/remove-members`, {
          	administratorList: admin
        })
        .then(administrator => {
			setTimeout(() => {
				this.loadData();
			}, 500);
        });
    },
    removeAdvisor: async function(id) {
    	let advisor = this.advisors.filter((advisor, index) => {
    		if (advisor._id === id) {
    			return advisor;
    		}
    	});
    	await this.api
        .post(`communities/${this.community_id}/remove-members`, {
          	advisorList: advisor
        })
        .then(advisor => {
          	this.getMemberAdviser('advisors');
        });
    },
    expandchannel: function(id) {
		const index = this.opened.indexOf(id);
		if (index > -1) {
      	//this.opened.splice(index, 1)
      	} else {
      		this.opened.push(id)
      	}
		if (id == 'advisors' && this.advisorsList.length == 0) {
			this.getMemberAdviser(id);
		} else if (id == 'members' && this.membersList.length == 0) {
			this.getMemberAdviser(id);
		}
	},
	expandContent(id) {
		const index = this.opened.indexOf(id);
		if (index > -1) {
			this.opened.splice(index, 1)
		} else {
			this.opened.push(id)
		}
	},
	ifInArray: function (value) {
		return this.partnerCommunities.indexOf(value) > -1;
	},
	async updatePartnerCommunity() {
		await this.api
		.put(`communities/${this.community_id}/update-communities/`, {"community_id_arr": this.partnerCommunities})
		.then(community => {
			this.$emit("reload");
			//this.loadData();
			this.partnerCommunities = this.community.partnerCommunities = community.data.partnerCommunities;
			this.getMemberAdviser('advisors', false);
		});
	},
	syncChannel: async function (index) {
		var channelId = this.community.channels[index]._id;
		var isSync = this.community.channels[index].syncEnabled;
		await this.api
		.put(`communities/${this.community_id}/channel-sync/`, {"channel_id": channelId, 'isSync': isSync, 'index': index})
		.then(community => {
			this.$emit("reload");
		});
	},
	getBannerLabel(index) {
        const labels = {
            1: 'Request Email',
            2: 'Response Email',
            3: 'Asker Question Confirmation',
            4: 'Responder Thank You Email',
            5: 'Feedback Asker Email',
            6: 'Feedback Responder Email'
        };
        return labels[index];
    },
	addContent: async function (scope) {
		this.$validator.validateAll(scope).then(async community => {
			if (community) {
				this.content.requestForm.subjectLine = this.requestForm.subjectLine.trim() == '' ? 'Short summary ...' : this.requestForm.subjectLine;
				this.content.requestForm.question = this.requestForm.question.trim() == '' ? "I have a question about ..." : this.requestForm.question;
				this.content.feedbackRequestMessage = this.content.feedbackRequestMessage.trim() == '' ? this.feedbackRequestDefaultText : this.content.feedbackRequestMessage;
				this.content.donorAlertMessage = this.content.donorAlertMessage.trim() == '' ? this.donorAlertDefaultText : this.content.donorAlertMessage;

				this.requestForm.subjectLine = this.content.requestForm.subjectLine;
				this.requestForm.question = this.content.requestForm.question;
				if (this.content.emailFooter.trim() == '') {
					this.content.emailFooter = `<table width="100%" border="0" cellspacing="0" cellpadding="0">
							<tr>
								<td align="center" valign="top" class="date2"
											style="font-family:'Roboto Slab', Georgia, 'Times New Roman', Times, serif;font-size:11px;line-height:17px;color:#CCCCCC;padding-left:50px; padding-right:50px;">
									<br />
									<a href="{{ landingPageURL }}" target="_blank" style="text-decoration:none;color:#000000;">Learn More</a>&nbsp;|&nbsp;
									<a href="{{ termsConditionsURL }}" target="_blank" style="text-decoration:none;color:#000000;">Terms Of Use</a> &nbsp;|&nbsp;
									<a href="{{ unsubscribePageURL }}" target="_blank" style="text-decoration:none;color:#000000;">Opt Out</a>
								</td>
							</tr>
							<tr>
								<td align="center" valign="top" style="padding:30px;">
									<a href="#" target="_blank">
										<img src='{{ community.customSettings.organizationURL }}'alt="Powered by Protopia" width="140"
												height="50" border="0" />
									</a>
								</td>
							</tr>
							<tr>
								<td class="cmm_hide" style="line-height:1px;min-width:634px;background-color:#ffffff;">
									<img alt="" src="https://storage.googleapis.com/protopia/app/email/spacer.gif" height="1" width="634"
												style="max-height:1px; min-height:1px; display:block; width:634px; min-width:634px;" border="0" />
								</td>
							</tr>
						</table>`;
				}
				await this.api
				.put(`communities/${this.community_id}/update-content/`, this.content)
				.then(community => {
					this.$emit("reload");
					this.saveContentText = "saved";
				});
			}
		});
	},
	addRequestContent: async function (scope) {
		this.$validator.validateAll(scope).then(async community => {
			if (community) {
				let isValidate = true;
				this.memberRoleValue = this.chatbotMemberRoleValue = this.adviceAreaValue = this.chatbotAdviceAreaValue = false;

				const memberRoleCount = this.configureFields.memberRole.value.split(",");
				if (memberRoleCount.length > 15) {
					this.memberRoleValue = true;
					isValidate = false;
				}
				const chatbotRoleCount = this.configureFields.memberRole.chatbotValue.split(",");
				if (chatbotRoleCount.length > 15) {
					isValidate = false;
					this.chatbotMemberRoleValue = true;
				}
				const adviceAreaCount = this.configureFields.adviceArea.value.split(",");
				if (adviceAreaCount.length > 6) {
					this.adviceAreaValue = true;
					isValidate = false;
				}
				const chatbotAdviceAreaCount = this.configureFields.adviceArea.chatbotValue.split(",");
				if (chatbotAdviceAreaCount.length > 6) {
					isValidate = false;
					this.chatbotAdviceAreaValue = true;
				}
				if (isValidate) {
					const payload = this.configureFields;
					await this.api
					.put(`communities/${this.community._id}/update-label`, payload)
					.then(community => {
						this.configureFields = payload;
					});

					this.content.requestForm.subjectLine = this.requestForm.subjectLine.trim() == '' ? 'Short summary ...' : this.requestForm.subjectLine;
					this.content.requestForm.question = this.requestForm.question.trim() == '' ? "I have a question about ..." : this.requestForm.question;

					this.requestForm.subjectLine = this.content.requestForm.subjectLine;
					this.requestForm.question = this.content.requestForm.question;
					await this.api
					.put(`communities/${this.community_id}/update-content/`, this.content)
					.then(community => {
						this.$emit("reload");
						this.requestSaveContentText = "saved";
					});
				}
			}
		});
	},
	searchAdvisorsBtn: async function() {
		if (this.searchAdvisors !== "" && this.advisors) {
			var searchParam = this.searchAdvisors.toLowerCase();
			await this.api.get(`communities/${this.community_id}/search-members?section=advisors&term=${searchParam}`)
			.then(response => {
				if (response.data.results) {
					this.advisorsList = response.data.results;
				}
			});
		}
	},
	searchAdvisorsFromList: function () {
		if (this.searchAdvisors === "" && this.advisors) {
			this.advisorsList = this.advisors;
		}
	},
	searchMemberBtn: async function() {
		if (this.searchMembers !== "") {
			var searchParam = this.searchMembers.toLowerCase();
			await this.api.get(`communities/${this.community_id}/search-members?section=members&term=${searchParam}`)
			.then(response => {
				if (response.data.results) {
					this.membersList = response.data.results;
				}
			});
		}
	},
	searchMembersFromList: function () {
		if (this.searchMembers === "") {
			this.membersList = this.members;
		}
	},
	sanitizeInput(input) {
            return sanitizeInput(input);
        },
        sanitizeUrl(url) {
            return sanitizeUrl(url);
        },
        ensureHttpsScheme(url) {
            return ensureHttpsScheme(url);
        },
        sanitizeHtmlTemplate(template) {
            return sanitizeHtmlTemplate(template);
        },
        sanitizeResourceDescription(description) {
            return sanitizeResourceDescription(description);
        },
		sanitizeCss(css) {
			return sanitizeCss(css);
		},
		sanitizeScript(script) {
			return sanitizeScript(script);
		},
		sanitizeHtmlAttributes(attributes) {
			return sanitizeHtmlAttributes(attributes);
		},
	async uploadMembersNew($event) {
		if ($event.target.files.length) {
			var file = $event.target.files[0];
			if (file.name.split(".").pop() !== 'csv') {
				this.$toast.error('Please select csv file type');
			} else {
				let reader = new FileReader();
				reader.readAsText(file, "UTF-8");
				reader.onload = (readerDone) => {
					let payload = {data: readerDone.target.result, fileName: file.name}
					this.api.post(`communities/${this.community_id}/upload-members`, payload).then(response => {
						this.$toast.success('File uploaded. The Dashboard will be updated once the import has finished');
					}).catch((err) => {
						this.$toast.error(`Error: File failed to upload. ${err}`);
					})
				}
			}
			$("#upload-members").val('');
		}
	},
	async uploadResourcesNew($event) {
		if ($event.target.files.length) {
			var file = $event.target.files[0];
			if (file.name.split(".").pop() !== 'csv') {
				this.$toast.error('Please select csv file type');
			} else {
				let reader = new FileReader();
				reader.readAsText(file, "UTF-8");
				reader.onload = (readerDone) => {
					let payload = {data: readerDone.target.result, fileName: file.name, roles: this.configureFields.memberRole.value}
					this.api.post(`communities/${this.community_id}/upload-resources`, payload).then(response => {
						this.$toast.success('File uploaded. The Dashboard will be updated once the import has finished');
					}).catch((err) => {
						this.$toast.error(`Error: File failed to upload. ${err}`);
					})
				}
			}
			$("#upload-members").val('');
		}
	},
	async downloadResources() {
		this.isDownloadBtnDisabled = true;
		console.log("--download resources--", this.community_id);
		this.api.post(`communities/${this.community_id}/download-resources`, {}).then(async response => {
			if (response.data.length) {
				console.log("community [resources]:", this.community.name);
				await exportCSV(response.data.slice(), `Resources-${this.community.name}`, ['_id', '__v', 'createdAt', 'updatedAt'], ['resource_createdAt']);
				this.$toast.success('File downloaded successfully!');
            } else {
				this.$toast.success('No resources available for this community.');
			}
			this.isDownloadBtnDisabled = false;
		}).catch((err) => {
			this.isDownloadBtnDisabled = false;
			this.$toast.error(`Error: File failed to download. ${err}`);
		})
	},
	// Bulk opportunities CSV — hits core-api directly (not the legacy hermes API).
	async downloadOpportunitiesTemplate() {
		this.isOpportunityTemplateDownloading = true;
		try {
			const token = localStorage.getItem('auth0_token');
			const res = await axios.get(`${CORE_API_URL}/api/opportunities/csv-template`, {
				headers: token ? { Authorization: `Bearer ${token}` } : {},
				responseType: 'text',
				transformResponse: [(data) => data],
			});
			const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = 'opportunities-import-template.csv';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
			this.$toast.success('Template downloaded.');
		} catch (err) {
			// eslint-disable-next-line no-console
			console.error('[downloadOpportunitiesTemplate]', err);
			this.$toast.error(`Failed to download template: ${err.message || err}`);
		} finally {
			this.isOpportunityTemplateDownloading = false;
		}
	},
	async uploadOpportunitiesNew($event) {
		if (!$event.target.files.length) return;
		const file = $event.target.files[0];
		if (file.name.split('.').pop().toLowerCase() !== 'csv') {
			this.$toast.error('Please select csv file type');
			$('#upload-opportunities').val('');
			return;
		}
		this.isOpportunityUploading = true;
		try {
			const token = localStorage.getItem('auth0_token');
			const formData = new FormData();
			// communityId must precede the file part: core-api only parses fields sent before it.
			formData.append('communityId', this.community_id);
			formData.append('file', file);
			const res = await axios.post(
				`${CORE_API_URL}/api/opportunities/import`,
				formData,
				{ headers: token ? { Authorization: `Bearer ${token}` } : {} },
			);
			const totalRows = (res.data && res.data.totalRows) || 0;
			const created = (res.data && res.data.created) || 0;
			const failed = (res.data && res.data.failed) || [];
			// core-api records every import, so re-read the shared history instead of tracking it locally.
			await this.loadOpportunityUploads();
			if (created > 0 && failed.length === 0) {
				this.$toast.success(`Imported ${created} of ${totalRows} opportunities.`);
			} else if (created > 0) {
				this.$toast.success(`Imported ${created} of ${totalRows}. ${failed.length} row(s) failed — see details below.`);
			} else {
				this.$toast.error(`No opportunities imported. ${failed.length} row(s) failed — see details below.`);
			}
		} catch (err) {
			// eslint-disable-next-line no-console
			console.error('[uploadOpportunitiesNew]', err);
			const msg = (err.response && err.response.data && (err.response.data.message || err.response.data.error))
				|| err.message
				|| String(err);
			this.$toast.error(`Upload failed: ${msg}`);
		} finally {
			this.isOpportunityUploading = false;
			$('#upload-opportunities').val('');
		}
	},
	async loadOpportunityUploads() {
		try {
			const token = localStorage.getItem('auth0_token');
			const res = await axios.get(`${CORE_API_URL}/api/communities/${this.community_id}`, {
				headers: token ? { Authorization: `Bearer ${token}` } : {}
			});
			// core-api logs every CSV import as a 'csv_import' entry on recruiting.activityLog (oldest first).
			const activityLog = (res.data && res.data.recruiting && res.data.recruiting.activityLog) || [];
			this.opportunityUploads = activityLog
				.filter(entry => entry.action === 'csv_import')
				.reverse()
				.map(({ _id, when, event = {} }) => ({
					_id,
					when,
					fileName: event.fileName,
					created: event.created || 0,
					duplicates: event.duplicates || 0,
					failedCount: event.failed || 0,
					failed: event.failedRows || []
				}));
		} catch (err) {
			// eslint-disable-next-line no-console
			console.error('[loadOpportunityUploads]', err);
			this.opportunityUploads = [];
		}
	},
	toggleOpportunityFailed(uploadId) {
		this.$set(this.opportunityFailedVisible, uploadId, !this.opportunityFailedVisible[uploadId]);
	},
	isOpportunityFailedVisible(uploadId) {
		return !!this.opportunityFailedVisible[uploadId];
	},
	toggleUploadSection(section) {
		this.openUploadSection = this.openUploadSection === section ? null : section;
	},
	onCountryChange() {
    this.selectedState = '';
    this.states = this.statesByCountry[this.selectedCountry.code] || [];
	},
	async handleUpload($event) {
		if ($event.target.files.length) {
			var file = $event.target.files[0];
			if (file.name.split(".").pop() !== 'csv') {
				this.$toast.error('Please select csv file type');
			} else {
				if (file.size <= 100000000) {
					let reader = new FileReader();
					await reader.readAsText(file, "UTF-8");
					reader.onload = (evt) => this.getUploadMemberData(evt, $event, 'import-member');
				} else {
					this.$toast.error(`File not uploaded successfully, file size is greater than 100MB, Try again with valid file size. ${file.size}`);
				}
			}
		}
	},
	async sortAdvisor(sorting, type) {
		if (this.advisorsList.length) {
			if (type === 'emails') {
				this.currentAdvisorSortEmail = sorting;
			} else if (type === 'requestReceived.lastRequestReceived') {
				this.currentAdvisorSortRequest = sorting;
			} else if (type === 'response.lastResponse') {
				this.currentAdvisorSortResponse = sorting;
			} else if (type === 'lastFeedback') {
				this.currentAdvisorSortLastFeedback = sorting;
			} else if (type === 'displayName') {
				this.currentAdvisorSortDisplayName = sorting;
			}
			var uri = ''
			if (this.searchAdvisors !== "") {
				uri = `communities/${this.community_id}/sort-advisors?field=${type}&sortBy=${sorting}&term=${this.searchAdvisors.toLowerCase()}`
			} else {
				uri = `communities/${this.community_id}/sort-advisors?field=${type}&sortBy=${sorting}`
			}
			await this.api
			.get(uri)
			.then(async response => {
				if (response.data.advisors) {
					this.advisorsList = this.advisors = response.data.advisors;
				}
			});
		}
	},
	async sortMember(sorting, type) {
		if (this.membersList.length) {
			if (type === 'emails') {
				this.currentMemberSortEmail = sorting;
			} else if (type === 'request.lastRequest') {
				this.currentMemberSortRequest = sorting;
			} else if (type === 'response.lastResponse') {
				this.currentMemberSortResponse = sorting;
			} else if (type === 'lastFeedback') {
				this.currentMemberSortLastFeedback = sorting;
			} else if (type === 'displayName') {
				this.currentMemberSortDisplayName = sorting;
			}
			var uri = ''
			if (this.searchMembers !== "") {
				uri = `communities/${this.community_id}/sort-members?field=${type}&sortBy=${sorting}&term=${this.searchMembers.toLowerCase()}`
			} else {
				uri = `communities/${this.community_id}/sort-members?field=${type}&sortBy=${sorting}`
			}
			await this.api
			.get(uri)
			.then(async response => {
				if (response.data.members) {
					this.membersList = this.members = response.data.members;
				}
			});
		}
	},
	sortCIName(sorting, sortFor) {
		var sFor = '';
		if (sortFor === 'member') {
			sFor = this.membersList;
		} else {
			sFor = this.advisorsList;
		}
		var narr = sFor.sort(function (a, b) {
			var aval = '';
			var bval = '';
			if (typeof a.first !== 'undefined') {
				aval = a.first;
				bval = b.first || b.displayName;
			} else {
				aval = a.displayName;
				bval = b.first || b.displayName;
			}
			if (sorting === 'asc') {
				return aval.toLowerCase().localeCompare(bval.toLowerCase());
			} else {
				return bval.toLowerCase().localeCompare(aval.toLowerCase());
			}
		});
		sFor = narr;
	},
	sortCIEmail(sorting, sortFor) {
		var sFor = '';
		if (sortFor === 'member') {
			sFor = this.membersList;
		} else {
			sFor = this.advisorsList;
		}
		var narr = sFor.sort(function (a, b) {
			if (sorting === 'asc') {
				return a.emails[0].toLowerCase().localeCompare(b.emails[0].toLowerCase());
			} else {
				return b.emails[0].toLowerCase().localeCompare(a.emails[0].toLowerCase());
			}
		});
		sFor = narr;
	},
    submitSiteStatus: async function(scope) {
        this.$validator.validateAll(scope).then(async valid => {
        	if (valid) {
				this.settings.suApproval = this.community.suApproval;
				this.settings.suApprovalRequest = this.suApprovalRequest;
				this.settings.suApprovalResponse = this.suApprovalResponse;
				this.settings.mgmtRequest = this.mgmtRequest;
				this.settings.mgmtResponse = this.mgmtResponse;
				this.settings.suAlert = this.suAlert;
				await this.api.post(`communities/${this.community_id}/update-site-status`, {
			      settings: this.settings
			    })
			    .then(community => {
					this.loadData();
					this.saveSiteStatusText = 'Saved';
			      //this.community = community.data;
				});
			}
	  	});
	},
	submitMatchingAlgorithm: async function(scope) {
		this.$validator.validateAll(scope).then(async valid => {
			if (valid) {
				await this.api.post(`communities/${this.community_id}/update-matching-algorithm`, {
			      	matchingAlgo: this.matchingAlgorithm
			    })
			    .then(community => {
					this.loadData();
					this.saveSiteStatusText = 'Saved';
				});
			}
		});
	},
	loadAdvisors: async function() {
		this.skipAdvisors += 1;
		await this.api
		.get(`communities/${this.community_id}/load-advisors?skip=${this.skipAdvisors}`)
		.then(async response => {
			if (response.data.advisors) {
				var advisors = this.advisorsList.slice().concat(response.data.advisors);
				this.advisorsList = advisors;
				this.advisors = advisors;
			}
		});
	},
	loadMembers: async function() {
		this.skipMembers += 1;
		await this.api
		.get(`communities/${this.community_id}/load-members?skip=${this.skipMembers}`)
		.then(async response => {
			if (response.data.members) {
				var members = this.membersList.slice().concat(response.data.members);
				// var uniqAdvisors = this.$lodash.uniqBy(advisors, '_id');
				this.membersList = members;
				this.members = members;
				// await this.sortMember('desc', 'displayName');
			}
		});
	},
	deleteChannel: async function (channelId) {
		if (channelId !== '' && typeof channelId !== 'undefined') {
			await this.api.post(`communities/channel/${this.community_id}`, {
				cId: channelId
				})
				.then(retComm => {
					this.community.channels = retComm.data;
					this.activeChannel = false;
			});
		}
	},
	showMembersLoadMore() {
		if (this.searchMembers !== "") {
			return this.membersList.length >= this.showSearchMember
		} else {
			return this.membersList.length >= this.showMember
		}
	},
	showAdvisorsLoadMore() {
		if (this.searchAdvisors !== "") {
			return this.advisorsList.length >= this.showSearchAdvisor
		} else {
			return this.advisorsList.length >= this.showAdvisors
		}
	},
	async loadMembersWithApi(searchText) {
		if (this.searchMembers !== "" && searchText.toLowerCase() === this.searchMembers.toLowerCase()) {
			this.showSearchMember += this.showTotalRecord;
			var searchParam = this.searchMembers.toLowerCase();
			this.skipSearchMembers += 1;
			await this.api
			.get(`communities/${this.community_id}/search-members?section=members&term=${searchParam}&skip=${this.skipSearchMembers}`)
			.then(response => {
				if (response.data.results) {
					var members = this.membersList.concat(response.data.results);
					// var uniqAdvisors = this.$lodash.uniqBy(advisors, '_id');
					this.membersList = members;
					this.members = members;
					// await this.sortMember('desc', 'displayName');
				}
			});
		} else {
			this.skipSearchMembers = 0;
			this.showMember += this.showTotalRecord;
			this.loadMembers()
		}
	},
	async loadAdvisorsWithApi(searchText) {
		if (this.searchAdvisors !== "" && searchText.toLowerCase() === this.searchAdvisors.toLowerCase()) {
			this.showSearchAdvisor += this.showTotalRecord;
			var searchParam = this.searchAdvisors.toLowerCase();
			this.skipSearchAdvisors += 1;
			await this.api
			.get(`communities/${this.community_id}/search-members?section=advisors&term=${searchParam}&skip=${this.skipSearchAdvisors}`)
			.then(response => {
				if (response.data.results) {
					var advisors = this.advisorsList.concat(response.data.results);
					this.advisorsList = advisors;
					this.advisors = advisors;
				}
			});
		} else {
			this.skipSearchAdvisors = 0;
			this.showAdvisors += this.showTotalRecord;
			this.loadAdvisors()
		}
	},
	rulesValidate: async function(field) {
		this.$validator.validateAll().then(async rules => {
			if (rules) {
				if (!this.validateSemesterSummary()) {
					return;
				}
				var payload = {
					matchingThreshold: this.matchingThreshold,
					minimum_advisors_ratio: this.minimum_advisors_ratio,
					minimum_responses_ratio: this.minimum_responses_ratio,
					approvalRequest: this.community.rules.approvalRequest,
					approvalResponse: this.community.rules.approvalResponse,
					AIapprovalRequest: this.community.rules.AIapprovalRequest || false,
					firstRequestReminder: this.community.rules.firstRequestReminder,
					secondRequestReminder: this.community.rules.secondRequestReminder,
					feedbackReminder: this.community.rules.feedbackReminder,
					geminiMatching: this.community.rules.geminiMatching,
					geminiMinimumTerms: this.community.rules.geminiMinimumTerms,
					askAgainFeedbackFrequency: {
						low: this.askAgainFeedbackFrequency.low,
						medium: this.askAgainFeedbackFrequency.medium,
						high: this.askAgainFeedbackFrequency.high
					},
					memberEngagementEmail: this.community.rules.memberEngagementEmail,
					feedbackFrequencyToRequest: this.community.rules.feedbackFrequencyToRequest,
					browserNewsletter: this.community.rules.browserNewsletter,
					browserNewsletterDay: this.community.rules.browserNewsletterDay || 'Friday',
					days: this.days,
					minimum_advisors: this.minimum_advisors,
					maximum_advisors: this.maximum_advisors,
					automaticallyCloseRequest: this.community.rules.automaticallyCloseRequest,
					semesterSummary: this.semesterSummary,
					workflow: this.community.rules.workflow,
					requestReceivedReduction: this.community.rules.requestReceivedReduction || 0,
					responseSharedDiscount: this.community.rules.responseSharedDiscount || 0,
					volunteerEscalations: this.community.rules.volunteerEscalations,
					superEscalatedAdvisors: this.community.rules.superEscalatedAdvisors || 10
				};
				console.log("SEMSUM: ", this.semesterSummary);
				let checkDataExists = Object.entries(payload);
				if (checkDataExists.length) {
					await this.api
					.put(`communities/${this.community._id}/update-rules`, payload)
					.then(community => {
						if (community.data && community.data.rules) {
							this.community.rules.requestReceivedReduction = community.data.rules.requestReceivedReduction
							this.community.rules.responseSharedDiscount = community.data.rules.responseSharedDiscount
							this.matchingThreshold = community.data.rules.matchingThreshold;
						}
						this.saveRulesText = 'Saved';
					});
				}
			}
		});
	},
	initialValidation: async function() {
		if (!this.configureFields.firstName.labelName) {
			this.configureFields.firstName.labelName = 'First Name';
		} else if (!this.configureFields.lastName.labelName) {
			this.configureFields.lastName.labelName = 'Last Name';
		} else if (!this.configureFields.emailAddress.labelName) {
			this.configureFields.emailAddress.labelName = 'Email Address';
		} else if (!this.configureFields.subject.labelName) {
			this.configureFields.subject.labelName = 'Subject Line';
		} else if (!this.configureFields.question.labelName) {
			this.configureFields.question.labelName = 'Question';
		} else if (!this.configureFields.classYear.labelName) {
			this.configureFields.classYear.labelName = 'Class Year';
		} else if (!this.configureFields.classYear.chatbotLabelName) {
			this.configureFields.classYear.chatbotLabelName = 'What year?';
		} else if (!this.configureFields.classYear2.labelName) {
			this.configureFields.classYear2.labelName = 'Class Year';
		} else if (!this.configureFields.classYear2.value) {
			this.configureFields.classYear2.value = this.generateArrayOfYears().toString();
		} else if (!this.configureFields.classYear2.chatbotLabelName) {
			this.configureFields.classYear2.chatbotLabelName = 'What year?';
		} else if (!this.configureFields.classYear2.chatbotValue) {
			this.configureFields.classYear2.chatbotValue = this.generateArrayOfYears().toString();
		} else if (!this.configureFields.title.labelName) {
			this.configureFields.title.labelName = 'Title';
		} else if (!this.configureFields.organization.labelName) {
			this.configureFields.organization.labelName = 'Organization';
		} else if (!this.configureFields.studentId.labelName) {
			this.configureFields.studentId.labelName = 'Student ID';
		} else if (!this.configureFields.dueDate.labelName) {
			this.configureFields.dueDate.labelName = 'Does your request have an expiration date?';
		} else if (!this.configureFields.linkedInProfile.labelName) {
			this.configureFields.linkedInProfile.labelName = 'LinkedIn profile';
		} else if (!this.configureFields.phoneNumber.labelName) {
			this.configureFields.phoneNumber.labelName = 'Mobile phone number';
		} else if (!this.configureFields.referrer.labelName) {
			this.configureFields.referrer.labelName = `How did you hear about ${this.community.name} ?`;
		} else if (!this.configureFields.referrer2.labelName) {
			this.configureFields.referrer2.labelName = `How did you hear about ${this.community.name} ?`;
		} else if (!this.configureFields.referrer2.value) {
			this.configureFields.referrer2.value = "Academic Advisor, Alumni Association, An Alum, Career Services , Career Fair , Email , Faculty , Flyer , A Friend , LinkedIn , Newsletter , Social Media , Used It Before , Website , Word Of Mouth";
		} else if (!this.configureFields.disclaimer.labelName) {
			this.configureFields.disclaimer.labelName = 'Please check this';
		} else if (!this.configureFields.memberRole.labelName) {
			this.configureFields.memberRole.labelName = 'In what capacity are you asking for help?';
		} else if (!this.configureFields.memberRole.value) {
			this.configureFields.memberRole.value = 'Alumni, Faculty, Staff, Student, Other';
		} else if (!this.configureFields.adviceArea.labelName) {
			this.configureFields.adviceArea.labelName = 'What type of request do you have?';
		} else if (!this.configureFields.adviceArea.value) {
			this.configureFields.adviceArea.value = 'Career, Academic, Entrepreneurship, Job Search, Project';
		} else if (!this.configureFields.college.labelName) {
			this.configureFields.college.labelName = 'School / Program / Degree';
		} else if (!this.configureFields.college2.labelName) {
			this.configureFields.college2.labelName = 'School / Program / Degree';
		} else if (!this.configureFields.college2.value) {
			this.configureFields.college2.value = 'Engineering, Chemistry, Physics, Math, Liberal Arts';
		} else if (!this.configureFields.college2.chatbotLabelName) {
			this.configureFields.college2.chatbotLabelName = 'What program do you (did you) attend?';
		} else if (!this.configureFields.college2.chatbotValue) {
			this.configureFields.college2.chatbotValue = 'Engineering, Chemistry, Physics, Math, Liberal Arts';
    } else if (!this.configureFields.major.labelName) {
			this.configureFields.major.labelName = 'Major';
		} else if (!this.configureFields.major.chatbotLabelName) {
			this.configureFields.major.chatbotLabelName = 'What is your major?';
		} else if (!this.configureFields.major.value) {
			this.configureFields.major.value = 'Accounting, Finance, Computer Science, Economics, Marketing';
		} else if (!this.configureFields.major.chatbotValue) {
			this.configureFields.major.chatbotValue = 'Accounting, Finance, Computer Science, Economics, Marketing';
    } else if (!this.configureFields.major.labelName) {
			this.configureFields.major.labelName = 'Major';
		} else if (!this.configureFields.college.chatbotLabelName) {
			this.configureFields.college.chatbotLabelName = 'What program do you (did you) attend?';
		} else if (!this.configureFields.firstName.chatbotLabelName) {
			this.configureFields.firstName.chatbotLabelName = 'What is your first name?';
		} else if (!this.configureFields.lastName.chatbotLabelName) {
			this.configureFields.lastName.chatbotLabelName = 'What is your last name?';
		} else if (!this.configureFields.emailAddress.chatbotLabelName) {
			this.configureFields.emailAddress.chatbotLabelName = 'Email Address';
		} else if (!this.configureFields.subject.chatbotLabelName) {
			this.configureFields.subject.chatbotLabelName = 'Subject Line';
		} else if (!this.configureFields.question.chatbotLabelName) {
			this.configureFields.question.chatbotLabelName = 'Question';
		} else if (!this.configureFields.title.chatbotLabelName) {
			this.configureFields.title.chatbotLabelName = "What's your job title?";
		} else if (!this.configureFields.organization.chatbotLabelName) {
			this.configureFields.organization.chatbotLabelName = 'What organization do you work for?';
		} else if (!this.configureFields.studentId.chatbotLabelName) {
			this.configureFields.studentId.chatbotLabelName = 'What is your student ID?';
		} else if (!this.configureFields.dueDate.chatbotLabelName) {
			this.configureFields.dueDate.chatbotLabelName = 'Does your request have an expiration date?';
		} else if (!this.configureFields.linkedInProfile.chatbotLabelName) {
			this.configureFields.linkedInProfile.chatbotLabelName = 'Do you have a LinkedIn profile? If so, what is the URL?';
		} else if (!this.configureFields.phoneNumber.chatbotLabelName) {
			this.configureFields.phoneNumber.chatbotLabelName = 'Can we text you occasionally alerts and reminders to help you engage?';
		} else if (!this.configureFields.disclaimer.chatbotLabelName) {
			this.configureFields.disclaimer.chatbotLabelName = 'Can you commit to courteous and quick follow up to ensure experts will continue to help others?';
		} else if (!this.configureFields.interest.description) {
			this.configureFields.interest.description = 'One more thing, please.\n\nOften, shared experiences and interests help us make even better matches. While not required, we would love for you to select one or more of the below topics you care about so that we can find the best experts to help you with your request.';
		} else if (!this.configureFields.memberRole.chatbotLabelName) {
			this.configureFields.memberRole.chatbotLabelName = 'In what capacity are you asking?';
		} else if (!this.configureFields.memberRole.chatbotValue) {
			this.configureFields.memberRole.chatbotValue = 'Alumni, Faculty, Staff, Student, Other';
		} else if (!this.configureFields.adviceArea.chatbotLabelName) {
			this.configureFields.adviceArea.chatbotLabelName = 'What type of request do you have?';
		} else if (!this.configureFields.adviceArea.chatbotValue) {
			this.configureFields.adviceArea.chatbotValue = 'Career, Academic, Entrepreneurship, Job Search, Project';
		}

	},
	labelValidate: async function(field) {
		if (!this.configureFields.firstName.labelName) {
			this.configureFields.firstName.labelName = 'First Name';
		} else if (!this.configureFields.lastName.labelName) {
			this.configureFields.lastName.labelName = 'Last Name';
		} else if (!this.configureFields.emailAddress.labelName) {
			this.configureFields.emailAddress.labelName = 'Email Address';
		} else if (!this.configureFields.subject.labelName) {
			this.configureFields.subject.labelName = 'Subject Line';
		} else if (!this.configureFields.question.labelName) {
			this.configureFields.question.labelName = 'Question';
		} else if (!this.configureFields.classYear.labelName) {
			this.configureFields.classYear.labelName = 'Class Year';
		} else if (!this.configureFields.classYear.chatbotLabelName) {
			this.configureFields.classYear.chatbotLabelName = 'What year?';
		} else if (!this.configureFields.classYear2.labelName) {
			this.configureFields.classYear2.labelName = 'Class Year';
		} else if (!this.configureFields.classYear2.value) {
			this.configureFields.classYear2.value = this.generateArrayOfYears().toString();
		} else if (!this.configureFields.classYear2.chatbotLabelName) {
			this.configureFields.classYear2.chatbotLabelName = 'What year?';
		} else if (!this.configureFields.classYear2.chatbotValue) {
			this.configureFields.classYear2.chatbotValue = this.generateArrayOfYears().toString();
		} else if (!this.configureFields.title.labelName) {
			this.configureFields.title.labelName = 'Title';
		} else if (!this.configureFields.organization.labelName) {
			this.configureFields.organization.labelName = 'Organization';
		} else if (!this.configureFields.studentId.labelName) {
			this.configureFields.studentId.labelName = 'Student ID';
		} else if (!this.configureFields.dueDate.labelName) {
			this.configureFields.dueDate.labelName = 'Does your request have an expiration date?';
		} else if (!this.configureFields.linkedInProfile.labelName) {
			this.configureFields.linkedInProfile.labelName = 'LinkedIn profile';
		} else if (!this.configureFields.phoneNumber.labelName) {
			this.configureFields.phoneNumber.labelName = 'Mobile phone number';
		} else if (!this.configureFields.referrer.labelName) {
			this.configureFields.referrer.labelName = `How did you hear about ${this.community.name} ?`;
		} else if (!this.configureFields.referrer2.labelName) {
			this.configureFields.referrer2.labelName = `How did you hear about ${this.community.name} ?`;
		} else if (!this.configureFields.referrer2.value) {
			this.configureFields.referrer2.value = "Academic Advisor, Alumni Association, An Alum, Career Services , Career Fair , Email , Faculty , Flyer , A Friend , LinkedIn , Newsletter , Social Media , Used It Before , Website , Word Of Mouth";
		} else if (!this.configureFields.disclaimer.labelName) {
			this.configureFields.disclaimer.labelName = 'Please check this';
		} else if (!this.configureFields.memberRole.labelName) {
			this.configureFields.memberRole.labelName = 'In what capacity are you asking for help?';
		} else if (!this.configureFields.memberRole.value) {
			this.configureFields.memberRole.value = 'Alumni, Faculty, Staff, Student, Other';
		} else if (!this.configureFields.adviceArea.labelName) {
			this.configureFields.adviceArea.labelName = 'What type of request do you have?';
		} else if (!this.configureFields.adviceArea.value) {
			this.configureFields.adviceArea.value = 'Career, Academic, Entrepreneurship, Job Search, Project';
		} else if (!this.configureFields.college.labelName) {
			this.configureFields.college.labelName = 'School / Program / Degree';
		} else if (!this.configureFields.college2.labelName) {
			this.configureFields.college2.labelName = 'School / Program / Degree';
		} else if (!this.configureFields.college2.value) {
			this.configureFields.college2.value = 'Engineering, Chemistry, Physics, Math, Liberal Arts';
		} else if (!this.configureFields.college.chatbotLabelName) {
			this.configureFields.college.chatbotLabelName = 'What program do you (did you) attend?';
		} else if (!this.configureFields.firstName.chatbotLabelName) {
			this.configureFields.firstName.chatbotLabelName = 'What is your first name?';
		} else if (!this.configureFields.lastName.chatbotLabelName) {
			this.configureFields.lastName.chatbotLabelName = 'What is your last name?';
		} else if (!this.configureFields.emailAddress.chatbotLabelName) {
			this.configureFields.emailAddress.chatbotLabelName = 'Email Address';
		} else if (!this.configureFields.subject.chatbotLabelName) {
			this.configureFields.subject.chatbotLabelName = 'Subject Line';
		} else if (!this.configureFields.question.chatbotLabelName) {
			this.configureFields.question.chatbotLabelName = 'Question';
		} else if (!this.configureFields.title.chatbotLabelName) {
			this.configureFields.title.chatbotLabelName = "What's your job title?";
		} else if (!this.configureFields.organization.chatbotLabelName) {
			this.configureFields.organization.chatbotLabelName = 'What organization do you work for?';
		} else if (!this.configureFields.studentId.chatbotLabelName) {
			this.configureFields.studentId.chatbotLabelName = 'What is your student ID?';
		} else if (!this.configureFields.dueDate.chatbotLabelName) {
			this.configureFields.dueDate.chatbotLabelName = 'Does your request have an expiration date?';
		} else if (!this.configureFields.linkedInProfile.chatbotLabelName) {
			this.configureFields.linkedInProfile.chatbotLabelName = 'Do you have a LinkedIn profile? If so, what is the URL?';
		} else if (!this.configureFields.phoneNumber.chatbotLabelName) {
			this.configureFields.phoneNumber.chatbotLabelName = 'Can we text you occasionally alerts and reminders to help you engage?';
		} else if (!this.configureFields.disclaimer.chatbotLabelName) {
			this.configureFields.disclaimer.chatbotLabelName = 'Can you commit to courteous and quick follow up to ensure experts will continue to help others?';
		} else if (!this.configureFields.interest.description) {
			this.configureFields.interest.description = 'One more thing, please.\n\nOften, shared experiences and interests help us make even better matches. While not required, we would love for you to select one or more of the below topics you care about so that we can find the best experts to help you with your request.';
		} else if (!this.configureFields.memberRole.chatbotLabelName) {
			this.configureFields.memberRole.chatbotLabelName = 'In what capacity are you asking?';
		} else if (!this.configureFields.memberRole.chatbotValue) {
			this.configureFields.memberRole.chatbotValue = 'Alumni, Faculty, Staff, Student, Other';
		} else if (!this.configureFields.adviceArea.chatbotLabelName) {
			this.configureFields.adviceArea.chatbotLabelName = 'What type of request do you have?';
		} else if (!this.configureFields.adviceArea.chatbotValue) {
			this.configureFields.adviceArea.chatbotValue = 'Career, Academic, Entrepreneurship, Job Search, Project';
		}
		if (field == 'memberRoleValue') {
			this.memberRoleValue = false;
			const roleCount = this.configureFields.memberRole.value.split(",");
			if (roleCount.length > 15) {
				this.memberRoleValue = true;
			}
		} else if (field == 'chatbotMemberRoleValue') {
			this.chatbotMemberRoleValue = false;
			const roleCount = this.configureFields.memberRole.chatbotValue.split(",");
			if (roleCount.length > 15) {
				this.chatbotMemberRoleValue = true;
			}
		} else if (field == 'adviceAreaValue') {
			this.adviceAreaValue = false;
			let adviceAreaCount = this.configureFields.adviceArea.value.split(",");
			if (adviceAreaCount.length > 6) {
				this.adviceAreaValue = true;
			}
		} else if (field == 'chatbotAdviceAreaValue') {
			this.chatbotAdviceAreaValue = false;
			let adviceAreaCount = this.configureFields.adviceArea.chatbotValue.split(",");
			if (adviceAreaCount.length > 6) {
				this.chatbotAdviceAreaValue = true;
			}
		} else if (field == 'invalidMemberMessage') {
			if (!this.content.invalidMemberMessage) {
				this.content.invalidMemberMessage = "This community is for members only. Unfortunately we're not able to confirm your membership. If you believe this is an error, please contact the administrator of this community at {{ community.email }}. We apologize for the inconvenience.";
			}
		} else if (field == 'requestFormWizardPage2') {
			if (!this.content.requestFormWizardPage2) {
				this.content.requestFormWizardPage2 = "A great question will get you great answers (and connections). Here's a <a target='_blank' href='https://vimeo.com/577233028/1fa12ba1fe'>short video</a> on how to craft one.";
			}
		} else if (field == 'requestFormWizardPage3') {
			if (!this.content.requestFormWizardPage3) {
				this.content.requestFormWizardPage3 = "Here's what advisors will receive. Need to make a revision? Simply click 'Back' and edit.";
			}
		}
	},
	validateSuperUser: function(field) {
		this.superUserEmailValidate = false;
		if (this.suApprovalRequest || this.suApprovalResponse || this.mgmtRequestSU || this.mgmtResponseSU || this.suAlert.request || this.suAlert.response || this.suAlert.noResponse || this.suAlert.feedback || this.suAlert.altRequestSU || this.suAlert.altResponseSU) {
			this.superUserEmailValidate = true;
		}
	},
	addTemplate: function() {
		this.selectTemp.push({original: '', override: ''})
	},
	deleteRow: function(index) {
	  	this.selectTemp.splice(index, 1);
		this.originalTemp.splice(index, 1);
	},
	selectOriginal: async function (index, select) {
		this.originalTemp[index] = select;
	},
	submitTemplates: async function () {
		await this.api.put(`communities/${this.community_id}/override-template/`, {temp: this.selectTemp}).then(community => {
			this.selectTemp = community.data.overrideTemplate;
			this.saveContentText = "saved";
			this.$nextTick(() => {
          	// Change button text to "Save" after DOM update
			setTimeout(() => {
				this.saveContentText = "save";
			}, 1500); // Change back to "Save" after 1.5 seconds
			});
		});
	},
	submitEmails: async function(scope) {
		this.$validator.validateAll(scope).then(async rules => {
			if (rules) {
				let body = {
					template: this.selectTemplate,
					emails: this.emailAddresses
				}
				await this.api.post(`communities/${this.community_id}/send-email-to-member/`, body).then(community => {
					this.selectTemplate = '';
					this.emailAddresses = '';
					this.$toast.success('Email has been sent successfully!');
				});
			}
		});
	},
	saveCampaign: async function(scope) {
		this.$validator.validateAll(scope).then(async status => {
			if (status) {
				var campaign = this.campaign;
		      	await this.api.put(`communities/${this.community_id}/update-community-campaign`, {campaign: campaign}).then(community => {
		          	this.$emit("reload");
					this.community = {...this.community, ...community.data};
		        });
			}
		});
	},
	updateChannel: async function() {
		this.$validator.validateAll().then(async valid => {
			if (valid) {
				if (!this.friendlyNames.communityAsk) {
					this.friendlyNames.communityAsk = 'Community';
				}
				if (!this.friendlyNames.email) {
					this.friendlyNames.email = 'Email';
				}
				if (!this.friendlyNames.chatbot) {
					this.friendlyNames.chatbot = 'Chatbot';
				}
				if (!this.friendlyNames.requestForm) {
					this.friendlyNames.requestForm = 'Request Form';
				}
				if (!this.friendlyNames.requestForm2) {
					this.friendlyNames.requestForm2 = 'Request Form Long';
				}
				if (!this.friendlyNames.requestForm1) {
					this.friendlyNames.requestForm1 = 'Request Form Short';
				}
				await this.api.put(`communities/update-channel/${this.community_id}`, {friendlyNames: this.friendlyNames}).then(response => {
            		this.loadData();
				});
			}
		});
	},
	async changeProfileUpdate(value, type) {
		let updatedType = '';
		let showWarning = false;
		if (value > 0) {
			if (type != 'interests') {
				if (value == this.configureFields.profileUpdateInterest) {
					this.configureFields.profileUpdateInterest = 0;
					updatedType = 'Interests';
					showWarning = true;
				}
			}
			if (type != 'occupation') {
				if (value == this.configureFields.profileUpdateOccupation) {
					this.configureFields.profileUpdateOccupation = 0;
					updatedType = 'Occupation';
					showWarning = true;
				}
			}
			if (type != 'geography') {
				if (value == this.configureFields.profileUpdateGeography) {
					this.configureFields.profileUpdateGeography = 0;
					updatedType = 'Geography';
					showWarning = true;
				}
			}
			// if (type != 'biography') {
			// 	if (value == this.configureFields.profileUpdateBiography) {
			// 		this.configureFields.profileUpdateBiography = 0;
			// 		updatedType = 'Biography';
			// 		showWarning = true;
			// 	}
			// }
			if (type != 'phoneNumber') {
				if (value == this.configureFields.profileUpdatePhoneNumber) {
					this.configureFields.profileUpdatePhoneNumber = 0;
					updatedType = 'Phone Number';
					showWarning = true;
				}
			}
			// if (type != 'skills') {
			// 	if (value == this.configureFields.profileUpdateSkills) {
			// 		this.configureFields.profileUpdateSkills = 0;
			// 		updatedType = 'Skills';
			// 		showWarning = true;
			// 	}
			// }
			if (type != 'linkedInUrl') {
				if (value == this.configureFields.profileUpdateLinkedInUrl) {
					this.configureFields.profileUpdateLinkedInUrl = 0;
					updatedType = 'LinkedIn Url';
					showWarning = true;
				}
			}
			if (showWarning && updatedType != '') {
				Vue.$toast.info(updatedType + ` sequence updated, because same sequence cannot be repeated.`, {duration: 8000});
			}
		}
	},
	generateArrayOfYears() {
		var min = new Date().getFullYear()
		var max = min + 9
		var years = []

		for (var i = min; i <= max; i++) {
			years.push(i)
		}
		return years
	},
	validateTrackingScript(script) {
	  // Remove potentially dangerous tags and attributes
	  const sanitizedScript = sanitizeInput(script);

	  // Additional validation
	  const dangerousPatterns = [
	    /<script/i,
	    /javascript:/i,
	    /onerror/i,
	    /onclick/i,
	    /onload/i,
	    /onmouseover/i,
	    /iframe/i,
	    /alert/i,
	    /prompt/i,
	    /eval\(/i
	  ];

	  return !dangerousPatterns.some(pattern => pattern.test(script));
	},
	validateCommunityUrl(url) {
		const sanitizedUrl = sanitizeInput(url);
		const urlPattern = /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/;
		return urlPattern.test(sanitizedUrl);
	},
	resetSearch(type) {
		if (type == 'members') {
			this.searchMembers = '';
			// Reset the displayed list back to the original member list.
			this.membersList = this.members;
		} else if (type == 'advisors') {
			this.searchAdvisors = '';
			// Reset the displayed list back to the original advisor list.
			this.advisorsList = this.advisors;
		}
	}

}//end
};
</script>
<style scoped>
.location-fields .location-select {
  width: 100%;
  height: 40px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background: transparent;
  padding: 8px 0;
  font-size: 16px;
  font-family: inherit;
  color: rgba(0, 0, 0, 0.87);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  outline: none;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.location-fields .location-select:focus {
  border-bottom: 2px solid #1976d2;
  box-shadow: 0 1px 0 0 #1976d2;
}

.location-fields .location-select:disabled {
  color: rgba(0, 0, 0, 0.38);
  border-bottom-style: dotted;
  cursor: not-allowed;
}

.location-fields .location-input {
  width: 100%;
  height: 40px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background: transparent;
  padding: 8px 0;
  font-size: 16px;
  font-family: inherit;
  color: rgba(0, 0, 0, 0.87);
  outline: none;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.location-fields .location-input:focus {
  border-bottom: 2px solid #1976d2;
  box-shadow: 0 1px 0 0 #1976d2;
}

.location-fields .location-input::placeholder {
  color: rgba(0, 0, 0, 0.38);
}

.location-fields .location-label {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  line-height: 20px;
  pointer-events: none;
  transition: color 0.3s;
  margin-bottom: 0;
  display: block;
}

.location-fields .location-field-wrapper {
  position: relative;
  margin-bottom: 16px;
}

.location-fields .location-select-wrapper {
  position: relative;
}

.location-fields .location-select-wrapper::after {
  content: '▼';
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Community.vue